import React, { Component } from "react";
import { connect } from "react-redux";
import config from "../../config";
import { development, SERVICE_RESPONSE, RFC_FORMAT, FINISH_THE_RACE, F1_GRILL, ImageVoucherMIT_dev, ImageVoucherMIT_prod, Datos_Empresa, points_Card, json } from "../../libs/utils/Const";
import {
    TimeOut,
    NavBarCashier,
    DetailsItemSale,
    BillModal,
    RefundModal,
    DeliverModal,
    WithdrawalModal,
    InventoryModal,
    SalesModal,
    CashCutModal,
    SavedSalesModal,
    SearchModal,
    ClientsModal,
    InitialCashModal,
    TaxesModal,
    SelectAddressModal,
    ValidationModal,
    InvoiceDataModal,
    FormatQuotationModal,
    FormatOrderSaleModal,
    FormatInvoiceModal,
    RefSaleModal,
    AuthorizationModel,
    PdfViewer,
    SearchStockModal,
    GrossProfitModal,
    FormatDeliveryModal,
    DetailClientModal,
    FormatCanceledTicketModal,
    FormatAdvancePaymentModal,
    CommentsModal,
    BatchSelectionModal,
    AdvancePaymentInvoicesModal,
    RefundTicketModal,
    PaymentStatusListModal,
    CancelCFDI,
    PaymentModal,
    PriceWithTaxesModal,
    NewUpdateModal,
    ValidateDocFieldsModal,
    TerminalFunctions,
    NewCustomerModal,
    AreYouAgreeModal,
    NavBar,
    BreadCumb,
    ToolTip,
    RefundOfPaymentsModal,
    NotificationPointsCardModal
} from "../../components";
import { NewOrder, NewItemPayment, PointsCardModel, } from "../../components/NewOrder";
import { DISPATCH_ID, _ROUND, GROSSPROFIT, CURRENCY, FORMAT_NUMBER, SYMBOL, FULLNAME_FORMAT, ZIPCODE, STREET_FORMAT, BLOCK_FORMAT, CITY_FORMAT } from "../../libs/utils/Const";
import { ApiClient } from "../../libs/apiClient";
import "../../css/dashboard.css";
import "../../css/responsive.css";
import {
    BusinessPartnerPS,
    NewItem,
    UserFieldsItem,
    NewOrderSales,
    Addresses,
    PrintDocument,
    InfoByFolio,
    ResponseHeader,
    BillAddress,
    ShipAddress,
    ItemLine,
    PayMethodCounter,
    DocComments,
    DownPaymentToDraw,
    DocToPDFViewer,
    CashMovement,
    PaymentCardsInfo
} from "../../components/NewOrder";
import $ from "jquery";
import moment from "moment";
import { GeneralFunctions } from "../../components/index";
import packageJson from "../../../package.json";
import socketService from "../../libs/sockets/SocketService";
import { ToolTips } from "../../libs/utils/Const";
global.appVersion = packageJson.version;
const currentVersion = global.appVersion;
const _generalFunctions = new GeneralFunctions();
const apiClient = ApiClient.getInstance();
const tips = ToolTips.CounterTips;

class CounterReturns extends Component {
    //#region ########## GENERAL FUNCTIONS ##################
    constructor(props) {
        super(props);
        this.state = {
            showInitialCashModal: false,
            showCashCutModal: false,
            idWorkShift: "",
            newOrderModel: new NewOrderSales(),
            ShowRefundOfPaymentsModal: false,
            actionSale: "",
            pedido: "",
            ourInfoForReturn: null,
            canCancelDocument: false,
            relatedPayMethodsByDoc: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + "currentUser")),
            createdFromReserve: false,
            ItsReserveInvoice: false,
            infoCondiPagoReturn: {},
            newOrderModelCopia: new NewOrderSales(),
            showPDFViewer: false,
            isCancel: false,
            PointsCardModel: new PointsCardModel(),
            showAreYouAgreeModal_Join_e_Wallet: false,
            addingPay: true,
            checkboxDataTables: (new Map()),
            sendMailModel: {
                to: "",
                subject: "",
                docEntry: ""
            },
            docsToPrint: [],
            typeDocPrint: "",
            EditableDocModel: {
                street: "",
                county: "",
                city: "",
                block: "",
                zipCode: "",
                rfc: "",
                shipStreet: "",
                shipCounty: "",
                shipCity: "",
                shipBlock: "",
                shipZipCode: ""
            },
            ordersToAction: 0,
            editableMode: false,
            extraDocsToShow: [],
            indexTypeDocShow: 0,
            printhide: true,
            PaymentModel: {},
            PaymentStatus: [],
            groupNumList: [],
            initialDate: moment(new Date()).format("YYYY-MM-DD"),
            finalDate: moment(new Date()).format("YYYY-MM-DD"),
            ordersDocs: [],
            ordersSearchModel: {
                CardCode: "",
                DocNum: ""
            },
            detailDoc: {},
            PaymentSaleModel: new PayMethodCounter(),
            AvailablePayments: [],
            ItsReturnBill: false,
            isValidCFDI: false,
            ItsCreditInvoice: false,
            itsCancelCFDIAvailable: false,
            relatedDocs: [],
            EnableEditButton: false,
            ShowExtraActions: false,
            CancelFunction: null,
            cashCut: {},
            extraPaymentsCashCut: {},
            objCharge: {},
            totalCashCut: 0,
            TotalAmountSales: 0,
            numSalesCashCut: 0,
            moneyOuts: [],
            moneyEntries: [],
            lastDaySession: false,
            blindCashCut: true,
            ReturnedBlindCut: [],
            AuthorizationComments: [],
            showBatchSelectionModal: false,
            isAuthorization: false,
            relatedFolio: '',
            flagIfDocPointsCard: false,
            returnedPoints: 0,
            ifExistPayment: false,
            headerDocument: {},
            OptionsCancelCFDI: '00',
            UUIDRelational: '',
            reasonsListCreditDebit: [],
            bankOptions: [],
        };
    }

    componentDidMount = async () => {
        await this.SetBranchOfficeBillingCatalogs();
        await this.SetBranchOfficeInfo();
        await this.CheckWorkSession();
        await this.searchBanksOptions();
    }

    IsInteger(num) {
        return isNaN(num) ? false : num % 1 === 0;
    }

    UnitType = (unit) => {
        switch (Number(unit)) {
            case 2: return "g";
            case 3: return "Kg";
            default: return "";
        }
    }

    findInName(word, name) {
        return (name || "").toUpperCase().includes(word);
    }

    shortName(name) {
        if (this.findInName("EFECTIVO", name)) { return ("EFECTIVO") }
        if (this.findInName("CHEQUE", name)) { return ("CHEQUE") }
        if (this.findInName("TRANS", name)) { return ("TRANSFERENCIA") }
        if (this.findInName("NOTA", name)) { return ("NOTA DE CRÉDITO") }
        if (this.findInName("TARJ", name)) { return ("TARJETA") }
        return (name)
    }

    shortTypeName(type) {
        switch (Number(type)) {
            case 0: return "EFECTIVO";
            case 1: return "CHEQUE";
            case 2: return "TARJETA";
            case 3: return "TRANSFERENCIA";
            case 4: return "NOTA DE CRÉDITO";
            default: return type;
        }
    }

    selectTip = () => {
        const { Refund, Cancel, CancelSale } = tips;
        const action = this.state.actionSale;

        switch (action) {
            case "refund": return Refund;
            case "cancel": return Cancel;
            case "cancelSale": return CancelSale;
            default: return [];
        }
    }

    SendToLogin = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        showAlert({ type: "info", message: `ESTAS SIENDO REDIRIGIDO AL LOGIN. ESTO ES PLANEADO.`, timeOut: 99999 });
        localStorage.removeItem(config.localStorageNamed + "Token");
        localStorage.removeItem(config.localStorageNamed + "currentUser");
        localStorage.removeItem(config.localStorageNamed + "toogleNavBarItem");
        socketService.emit("logout", "");
        this.props.history.push("/");
        this.props.history.push("/login");
        window.location.reload(true);

    }

    GotoDashboard = () => {
        this.props.history.push("/");
    };

    selectTable = (view = null, docTypeMiddleware = null) => {
        let name = "";
        let complement = "";
        let docSubType = "";
        let docType = "";
        let name2 = "";
        let complement2 = "";
        let docSubType2 = "";
        let docType2 = "";
        let reserveInvoice = "N";

        switch (view) {
            case "quotations":
                name = "OQUT";
                complement = "QUT1";
                docSubType = "--";
                docType = "23";
                reserveInvoice = "N";
                break;
            case "orderSales":
                name = "ORDR";
                complement = "RDR1";
                docSubType = "--";
                docType = "17";
                reserveInvoice = "N";
                break;
            case "deliveries":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;
            case "deliveries2":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;
            case "deliveries3":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;
            case "invoice":
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                reserveInvoice = "N";
                break;
            case "invoiceReserve":
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                reserveInvoice = "Y";
                break;
            case "return":
                name = "ORDN";
                complement = "RDN1";
                docSubType = "--";
                docType = "16";
                reserveInvoice = "N";
                break;
            case "debitNote":
                name = "OINV";
                complement = "INV1";
                docSubType = "DN";
                docType = "13";
                reserveInvoice = "N";
                break;
            case "creditNote":
                name = "ORIN";
                complement = "RIN1";
                docSubType = "--";
                docType = "14";
                reserveInvoice = "N";
                break;
            case "downPayments":
                name = "ODPI";
                complement = "DPI1";
                docSubType = "--";
                docType = "203";
                reserveInvoice = "N";
                break;
            case "PurchaseOrder":
                name = "OPOR";
                complement = "POR1";
                docSubType = "--";
                docType = "22";
                break;
            case "purchaseReturn":
                name = "ORPD";
                complement = "RPD1";
                docSubType = "--";
                docType = "21";
                break;
            case "GoodsReceipt":
                name = "OPDN";
                complement = "PDN1";
                docSubType = "--";
                docType = "20";
                break;
            case "PurchaseRequest":
                name = "OPRQ";
                complement = "PRQ1";
                docSubType = "--";
                docType = "1470000113";
                break;
            case "purchaseInvoice":
                name = "OPCH";
                complement = "PCH1";
                docSubType = "--";
                docType = "18";
                break;
            case "purchaseCreditNotes":
                name = "ORPC";
                complement = "RPC1";
                docSubType = "--";
                docType = "19";
                break;




            case "transfers":
                name = "OWTR";
                complement = "WTR1";
                docSubType = "--";
                docType = "67";
                break;
            case "transfersRequest":
                name = "OWTQ";
                complement = "WTQ1";
                docSubType = "--";
                docType = "1250000001";
                break;
            case "transfersEntry":
                name = "OIGN";
                complement = "IGN1";
                docSubType = "--";
                docType = "59";
                break;
            case "transfersOutput":
                name = "OIGE";
                complement = "IGE1";
                docSubType = "--";
                docType = "60";
                break;
            case "bussinesPartner":
                name = "OCRD";
                complement = "CRD1";
                docSubType = "--";
                break;
            case "inventoryRevaluation":
                name = "OMRV";
                complement = "MRV1";
                docSubType = "--";
                docType = "162";
                break;
            case "payment":
                name = "ORCT";
                complement = "RCT1";
                docSubType = "--";
                docType = "24";
                break;
            case "outgoingPayment":
                name = "OVPM";
                complement = "VPM1";
                docSubType = "--";
                docType = "30";
                break;
            case "invoiceBorrador":
                name = "ODRF";
                complement = "DRF1";
                docSubType = "--";
                break;
            case "invoiceAuthorization":
                name = "OWDD";
                complement = "OWDD";
                docSubType = "--";
                break;

            case "deliveries4":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;


            default:
                name = "";
                complement = "";
                docSubType = "";
                docType = "13";
        }

        return {
            name,
            complement,
            docSubType,
            docType,
            name2,
            complement2,
            docSubType2,
            docType2,
            reserveInvoice,
        };
    };

    GetSeriesByCurrentUserProp = async (nameProperty) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state
        if (!_user?.hasOwnProperty(`${nameProperty}`)) return null;

        const seriesDocument = _user[nameProperty];
        if (seriesDocument) {
            enableSpinner(true);
            const serieResponse = await apiClient.validateSerialNumbers({ seriesDocument });
            enableSpinner(false);
            if (serieResponse.status === SERVICE_RESPONSE.SUCCESS) {
                return serieResponse.data;
            } else {
                showAlert({ type: "warning", message: serieResponse.message, timeOut: 5000 });
                return null;
            }
        } else { return null; }
    }

    BrakeRelationDoc = async () => {
        const { newOrderModel } = this.state
        let copyItems = [...newOrderModel.Items]
        for (let i = 0; i < copyItems.length; i++) {
            let item = copyItems[i];
            item.BaseLine = "";
            item.BaseEntry = "";
            item.BaseLine = "";
            item.BaseType = "-1";
        }
        newOrderModel.Items = copyItems;
        newOrderModel.DocEntry = "";
        newOrderModel.ComingFromRecoverQT = false;
        this.setState({
            chooseSavedSale: "",
            auxRecoverDocData: null,
            recoverDocument: false,
            showTemporalData: false,
            editModePartner: false,
            disableRecover: false,
            disableRecoverNM: false,
        });
        await this.refreshModel(newOrderModel);
    }
    //#endregion

    //#region ########## WORK SESION & CASH CUT #############
    CheckWorkSession = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.checkWorkSession();
        enableSpinner(false);

        if (responseApi.status === 1) {
            if (!responseApi.data.sessionStatus) {
                await this.ShowInitialCash();
            } else {
                if (responseApi.data.NotCashCut === true) {
                    showAlert({ type: "info", message: `${responseApi.message}. Realiza tu corte para continuar`, timeout: 10000 });
                    await this.setState({
                        idWorkShift: responseApi.data.idSession,
                        lastDaySession: true,
                    });
                    await this.ShowCashCutModal();
                    $("#cashCutModal").modal("show");
                } else {
                    this.setState({ idWorkShift: responseApi.data.idSession });
                }
            }
        } else if (responseApi.status === 2) {
            showAlert({ type: "info", message: `${responseApi.message}`, timeout: 10000 });
            this.GotoDashboard();
        }
    };

    searchBanksOptions = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        let banksRes = await apiClient.getBanksOptions();
        enableSpinner(false);
        if (!banksRes?.status) {
            showAlert({ type: 'warning', timeOut: 5000, message: banksRes?.message || "Ocurrió un error al obtener el listado de bancos dispobiles para los depósitos" });
        } else {
            this.setState({
                bankOptions: banksRes?.data ?? []
            })
        }
    }

    ShowInitialCash = async () => {
        await this.setState({
            showInitialCashModal: !this.state.showInitialCashModal,
        });

        $("#initialCashModal").modal("show");
    };

    ShowCashCutModal = async () => {
        await this.setState({
            showCashCutModal: !this.state.showCashCutModal,
        });
        if (this.state.showCashCutModal) await this.GetBoxCut();
    };

    GetBoxCut = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idWorkShift } = this.state;

        enableSpinner(true);
        const responseApi = await apiClient.partialCut(idWorkShift);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            this.CheckWorkSession();
            return;
        }

        $("#cashCutModal").modal("show");

        await this.setState({
            cashCut: responseApi.data.reportcashCut || "",
            totalCashCut: Number(responseApi.data.totalCashCut) || 0,
            TotalAmountSales: Number(responseApi.data.totalAmountSales) || 0,
            numSalesCashCut: Number(responseApi.data.numSales) || 0,
            objCharge: responseApi.data.objCharge || {},
            extraPaymentsCashCut: responseApi.data.extraPayments,
            moneyOuts: responseApi.data.moneyOuts,
            moneyEntries: responseApi.data.moneyEntries
        });
    };

    CancelWorkShift = () => {
        this.GotoDashboard();
    };

    CloseWorkShift = async (blindInfoModel) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idWorkShift } = this.state;
        const data = {
            idWorkShift,
            blindInfoModel
        }

        enableSpinner(true);
        const responseApi = await apiClient.closeWorkShiftT(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return false;
        }

        showAlert({ type: "info", message: `${responseApi.message}` });
        $("#totalModal").modal("show");
        await this.setState({
            lastDaySession: false,
            ReturnedBlindCut: responseApi.ReturnedBlindCut || [],
        })
        return true;
    };

    InsertWorkShiftT = async () => {
        const {
            enableSpinner,
            notificationReducer: { showAlert },
        } = this.props;
        enableSpinner(true);
        let responseApi = await apiClient.insertWorkShiftT();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }
        if (responseApi.status === 0) {
            this.GotoDashboard();
        }
        this.setState({ idWorkShift: responseApi.data.idSession });
    };

    ShowBlindCashCut = async () => {
        await this.setState({
            blindCashCut: !this.state.blindCashCut,
        });
    };
    //#endregion

    //#region ########## UPDATE FIELDS ######################
    refreshModel = async newOrderModel => {
        await this.setState({ newOrderModel })
    };

    RefreshOrder = async (newOrderModel) => {
        await this.setState({ newOrderModel });
    };

    RefreshPaymentSaleModel = (PaymentSaleModel) => {
        this.setState({ PaymentSaleModel })
    };

    CancelReturnPayment = () => {
        const { ShowRefundOfPaymentsModal } = this.state
        if (ShowRefundOfPaymentsModal) this.setState({ ShowRefundOfPaymentsModal: false });
    }

    ChangePedido = async (valor) => {
        await this.setState({
            pedido: valor,
            isValidCFDI: false,
            isCancel: false,
            newOrderModel: new NewOrderSales(),
        });
    }

    ChangeActionSale = async (value) => {
        await this.setState({ actionSale: value });
    }

    toggleDocumentSelected = (id) => {
        this.setState(state => {
            const checkboxDataTables = new Map(state.checkboxDataTables);
            checkboxDataTables.set(id, !checkboxDataTables.get(id));
            return { checkboxDataTables };
        });
    }

    toggleDocumentSelectedAll = (action) => {
        const { newOrderModel } = this.state;
        let newCheckbox = (new Map());

        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const register = newOrderModel.Items[index];
            if (Number(register.OpenQty) !== 0) newCheckbox.set(index, action);
        }

        this.setState({ checkboxDataTables: newCheckbox });
    }

    EnableShowRefundOfPaymentsModal = async () => {
        await this.setState({ ShowRefundOfPaymentsModal: !this.state.ShowRefundOfPaymentsModal, });
    }

    CloseOpenRefundOfPaymentsModal = async (show) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { actionSale, ourInfoForReturn, canCancelDocument, newOrderModel, relatedPayMethodsByDoc, isAuthorization } = this.state;
        const itsCreditInvoice = relatedPayMethodsByDoc && relatedPayMethodsByDoc.length > 0 ? relatedPayMethodsByDoc.find(element => Number(element.typeMethod) === -1) : false;
        const pedido = isAuthorization ? this.state.relatedFolio : this.state.pedido;

        if (actionSale === "cancel") {
            const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);
            if (pedido === "") return showAlert({ type: "warning", message: "No has solicitado ningún documento a cancelar." });
            if (infoFolio.folioID !== "IV") return showAlert({ type: "warning", message: "Solo es posible cancelar facturas de momento." });
            if (itsCreditInvoice && canCancelDocument) return showAlert({ type: "error", message: "No se puede cancelar el documento, ya tiene una nota de crédito relacionada." });
        }

        if (actionSale === "cancel" && ourInfoForReturn.isDeliveryInvoice === "Y" && ourInfoForReturn.paidOut === "N" && !itsCreditInvoice) {
            showAlert({ type: "info", message: "FACTURA A DOMICILIO NO PAGADA, SE CANCELARA EL CFDI" });
            await this.CloseDocument();
        } else if (actionSale === "cancel" && itsCreditInvoice && newOrderModel.ReceiptNum !== null) {
            const wasPayedTotally = Number(newOrderModel.AbonadoTotal) === Number(newOrderModel.DocTotal) ? true : false;
            if (wasPayedTotally || newOrderModel.payWasCanceled === "Y") {
                if (!this.state.ShowRefundOfPaymentsModal) await this.EnableShowRefundOfPaymentsModal();
                newOrderModel.DocStatus = "O";
                this.setState({ newOrderModel });
                $("#refundOfPaymentsModal").modal(show ? "show" : "hide");
            }
            else if (!wasPayedTotally || newOrderModel.payWasCanceled === "N") await this.CloseDocument(); // Nota de crédito no timbrada y no relacionada
        } else {
            const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);
            const data = { destino: infoFolio.table === "OINV" ? "ORIN" : "ORDN", docSubType: "--", model: {} };

            enableSpinner(true);
            const response = (!isAuthorization && development) ? await apiClient.autorizationModels(data) : {};
            enableSpinner(false);

            let autorization = [];
            if (response?.status === 1) {
                for (const element of response.autorization) {
                    autorization.push({ name: element.nameCond, id: element.wtm, comment: '' });
                }

                let autho = {};
                autorization = autorization.filter((element) => autho[element.id] ? false : autho[element.id] = true);
                this.setState({ AuthorizationComments: autorization });

                $('#authorizationModel').modal('show');
            } else {
                if (!this.state.ShowRefundOfPaymentsModal) await this.EnableShowRefundOfPaymentsModal();
                $("#refundOfPaymentsModal").modal(show ? "show" : "hide");
            }
        }
    }

    ChangeComments = async (event) => {
        const { newOrderModel } = this.state;
        newOrderModel.Comments = event.nativeEvent.target.value;
        await this.setState({ newOrderModel });
    }

    ChangeField = async (field, value) => {
        const { newOrderModel } = this.state;
        if (field === 'U_RS_SOLAPR') {
            let U_RS_SOLAPR = newOrderModel[field];
            if (!U_RS_SOLAPR) {
                value = 'Y'
            } else {
                value = U_RS_SOLAPR === 'Y' ? 'N' : 'Y';
            }
        }
        newOrderModel[field] = value;
        await this.setState({ newOrderModel });
    }

    RefreshReturnTotal = async (newOrderModel) => {
        const pedido = this.state.isAuthorization ? this.state.relatedFolio : this.state.pedido;
        const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);
        let linesVerified = [];
        let subTotal = 0;
        let impuestos = 0;
        let total = 0;

        for (let item of newOrderModel.Items) {
            if (infoFolio.folioID !== "IV") item.PriceBefDi = Number(item.Price);
            const discount = Number(item.PriceBefDi) * Number(item.Discount) / 100;
            const price = Number(item.PriceBefDi) - discount;
            const total = Number((price * item.newQuantity).toFixed(2));
            const taxLine = Number((total * Number(item.TaxRate) / 100).toFixed(3));

            item.Total = total.toFixed(2);
            item.TaxeResult = taxLine.toFixed(2);
            item.VatSum = Number(item.TaxeResult);

            const lineVerified = linesVerified.find(line => Number(line) === Number(item.AuxLineNum));
            if (isNaN(lineVerified)) {
                subTotal += Number(item.Total);
                impuestos += taxLine;
                linesVerified.push(isNaN(item.AuxLineNum) || item.AuxLineNum === "" ? -1 : item.AuxLineNum);
            }
        }

        total = Number(subTotal.toFixed(2)) + Number(impuestos.toFixed(2));
        newOrderModel.Subtotal = Number(subTotal).toFixed(2);
        newOrderModel.Taxes = Number(impuestos).toFixed(2);
        newOrderModel.Total = Number(total);

        this.setState({ newOrderModel });
    }

    AddPay = () => {
        this.setState({ addingPay: !this.state.addingPay });
    };

    SetBranchOfficeBillingCatalogs = async () => {
        const { enableSpinner } = this.props;
        const { reasonsListCreditDebit } = this.state;
        let _reasonsListCreditDebit = [];

        if (!reasonsListCreditDebit?.length || !Array.isArray(reasonsListCreditDebit)) {
            enableSpinner(true);
            const apiResponse = await apiClient.getBillingCatalogs();
            enableSpinner(false);

            if (apiResponse?.status === 1) {
                _reasonsListCreditDebit = Array.isArray(apiResponse?.data?.reasonsListCreditDebit) ? apiResponse.data.reasonsListCreditDebit : [];
            }
        } else { _reasonsListCreditDebit = reasonsListCreditDebit; }

        await this.setState({ reasonsListCreditDebit: _reasonsListCreditDebit })
    }

    SetBranchOfficeInfo = async () => {
        const { _user, newOrderModel } = this.state
        const auxArrayMethods = _user.Branch.PaymentMethods.slice() || [];
        const indexNC = auxArrayMethods.findIndex(object => { return object.code === "NC"; });
        if (indexNC !== -1) auxArrayMethods.splice(indexNC, 1);

        const indexCD = auxArrayMethods.findIndex(object => { return object.code === "CD"; });
        if (indexCD !== -1) auxArrayMethods.splice(indexCD, 1);

        await this.setState({
            LimitLinesBO: _user?.Branch.LimitLines || 0,
            CounterRol: _user?.U_FMB_CounterRol || null,
            AvailablePayments: auxArrayMethods || [],
            creditNotesPay: indexNC !== -1 ? true : false,
            creditPay: indexCD !== -1 ? true : false
        })
    }

    ChangeQuantityRefund = async (index, item, event) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;
        let newQuantity = event.nativeEvent.target.value;

        if (Number(newQuantity) > Number(item.OpenQty)) {
            newQuantity = Number(item.OpenQty);
            newOrderModel.Items[index].newQuantity = Number(newQuantity);
            if (newOrderModel.Items[index].ManBtchNum && newOrderModel.Items[index].ManBtchNum === "Y") {
                let auxBatchObject = newOrderModel.Items[index].BatchNumbers[0] || null;
                if (auxBatchObject !== null) auxBatchObject.Quantity = newQuantity;
                newOrderModel.Items[index].BatchNumbers = auxBatchObject !== null ? [auxBatchObject] : [];
            }
            await this.setState({ newOrderModel });
            return showAlert({ type: "warning", message: "No puedes devolver mas unidades", timeOut: 0 });
        } else {
            if (Number(newQuantity) <= Number(item.OpenQty) && Number(newQuantity) >= 0) {
                newOrderModel.Items[index].newQuantity = Number(newQuantity);
                if (newOrderModel.Items[index].ManBtchNum && newOrderModel.Items[index].ManBtchNum === "Y") {
                    let auxBatchObject = newOrderModel.Items[index].BatchNumbers[0] || null;
                    if (auxBatchObject !== null) auxBatchObject.Quantity = newQuantity;
                    newOrderModel.Items[index].BatchNumbers = auxBatchObject !== null ? [auxBatchObject] : [];
                }
                await this.setState({ newOrderModel });
            }
        }
    }
    //#endregion

    //#region ########## TIMBRA FUNCTIONS ###################
    ConsultarEstatusCFDI = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const pedido = this.state.isAuthorization ? this.state.relatedFolio : this.state.pedido;
        const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);

        const data = {
            DocEntry: infoFolio.DocEntry,
            Table: {
                name: infoFolio.table,
            }
        }

        enableSpinner(true);
        let response = await apiClient.ConsultarEstatusCFDI(data);
        enableSpinner(false);
        if (response.paymentStatus.length > 0) {
            await this.setState({
                PaymentStatus: response.paymentStatus
            });
            // $("#paymentStatusListModal").modal("show");
        }


        if (response.status === 1) { //Documento cancelado
            this.setState({
                isCancel: true,
                PaymentStatus: [],
            })
            return showAlert({ type: "success", message: `${pedido}: ${response.message ?? ""}`, timeOut: 8000 });
        } else if (response.status === 2) { //Cancelable 
            if (response.data.docNumBilling) {
                await this.setState({
                    OptionsCancelCFDI: '01',
                    UUIDRelational: response.data.docNumBilling || ''
                });
            }
            this.setState({
                isValidCFDI: true,
                PaymentStatus: response.paymentStatus || []
            })
            if (response.paymentStatus.length > 0) { $("#paymentStatusListModal").modal("show"); }
            return showAlert({ type: "info", message: `${pedido}: ${response.message ?? ""}`, timeOut: 8000 });
        } else {
            return showAlert({ type: "warning", message: `${pedido}: ${response.message ?? ""}`, timeOut: 8000 });
        }
    }

    ShowCancelConfirm = async (isInvoice) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { isAuthorization } = this.state;
        const data = { destino: "ORIN", docSubType: "--", model: {} };

        enableSpinner(true);
        const response = (!isAuthorization && development) ? await apiClient.autorizationModels(data) : {};
        enableSpinner(false);

        let autorization = [];
        if (response?.status === 1) {
            for (const element of response.autorization) {
                autorization.push({ name: element.nameCond, id: element.wtm, comment: '' });
            }

            let autho = {};
            autorization = autorization.filter((element) => autho[element.id] ? false : autho[element.id] = true);
            this.setState({ AuthorizationComments: autorization });

            $('#authorizationModel').modal('show');
        } else {
            $("#cancelCFDI").modal("show");
            if (this.state.OptionsCancelCFDI !== '00' && this.state.UUIDRelational !== '') {
                const selct = document.getElementById("selectCancelCFDI");
                const input = document.getElementById("U_FMB_UUID_RELACIONADO");
                if (selct) {
                    selct.value = this.state.OptionsCancelCFDI;
                }
                if (input) {
                    input.value = this.state.UUIDRelational || '';
                }
            } else {
                const selct = document.getElementById("selectCancelCFDI");
                if (selct) {
                    selct.value = '00';
                }
            }

            let CancelFunction = null;
            if (isInvoice) { CancelFunction = this.CancelCFDI; }
            else { CancelFunction = this.CancelPaymentCFDI; }
            await this.setState({ CancelFunction })
        }
    }

    CancelCFDI = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const pedido = this.state.isAuthorization ? this.state.relatedFolio : this.state.pedido;

        $("#cancelCFDI").modal("hide");
        const motivo = document.getElementById("selectCancelCFDI").value;
        const U_FMB_UUID_RELACIONADO = document.getElementById("U_FMB_UUID_RELACIONADO") !== null && document.getElementById("U_FMB_UUID_RELACIONADO") !== undefined ? document.getElementById("U_FMB_UUID_RELACIONADO").value : "";

        if (motivo === "00") {
            return showAlert({ type: "warning", message: `Parámetro inválido. El motivo de cancelacion no es un valor válido`, timeOut: 8000 });
        } else if (motivo === "01" && U_FMB_UUID_RELACIONADO === "") {
            return showAlert({ type: "warning", message: `Parámetro inválido. Debes de colocar un UUID`, timeOut: 8000 });
        }


        const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);
        const data = {
            DocEntry: infoFolio.DocEntry,
            Table: {
                name: infoFolio.table,
            },
            Motivo: motivo || "02",
            U_FMB_UUID_RELACIONADO: U_FMB_UUID_RELACIONADO || "",
        }
        $("#cancelDocuments").modal("hide");

        enableSpinner(true);
        const response = await apiClient.CancelCFDI(data);
        enableSpinner(false);

        $("#cancelCFDI").modal("hide");
        if (response.status === 0) {
            return showAlert({ type: "error", message: `${response.message ?? ""}`, timeOut: 8000 });
        } else if (response.status === 2) {
            return showAlert({ type: "info", message: `${response.message ?? ""}`, timeOut: 8000 });
        } else {
            this.setState({
                isCancel: true,
                isValidCFDI: false,
                OptionsCancelCFDI: '00',
                UUIDRelational: '',
            })
            return showAlert({ type: "success", message: `${response.message ?? ""}`, timeOut: 8000 });
        }
    };

    CancelPaymentCFDI = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { PaymentModel } = this.state;
        $("#cancelCFDI").modal("hide");

        let motivo = document.getElementById("selectCancelCFDI").value;
        const U_FMB_UUID_RELACIONADO = document.getElementById("U_FMB_UUID_RELACIONADO") !== null && document.getElementById("U_FMB_UUID_RELACIONADO") !== undefined ? document.getElementById("U_FMB_UUID_RELACIONADO").value : "";
        if (motivo === "00") return showAlert({ type: "warning", message: `Parámetro inválido. El motivo de cancelacion no es un valor válido`, timeOut: 8000 });
        else if (motivo === "01" && U_FMB_UUID_RELACIONADO === "") return showAlert({ type: "warning", message: `Parámetro inválido. Debes de colocar un UUID`, timeOut: 8000 });
        $("#cancelDocuments").modal("hide");

        let data = {
            DocEntry: PaymentModel.DocEntry,
            Table: {
                name: "ORCT",
            },
            Motivo: motivo || "02",
            U_FMB_UUID_RELACIONADO: U_FMB_UUID_RELACIONADO || "",
        }

        enableSpinner(true);
        let response = await apiClient.CancelCFDI(data);
        enableSpinner(false);

        PaymentModel.IsCancelSAP = !(response.status === 0 || response.status === 2);
        PaymentModel.StatusCFDI = !(response.status === 0 || response.status === 2);
        await this.setState({ PaymentModel })
        showAlert({ type: response.status === 0 ? "error" : response.status === 2 ? "info" : "success", message: `${response.message ?? ""}`, timeOut: 8000 });
    };

    ContinueToCancel = async () => {
        $("#paymentStatusListModal").modal("hide");
        await this.setState({ PaymentStatus: [], isValidCFDI: true })
    }

    CancelPayments = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { PaymentStatus } = this.state;
        if (!PaymentStatus?.length) return showAlert({ type: "warning", message: `Sin documentos por cancelar`, timeOut: 8000 });

        enableSpinner(true);
        let response = await apiClient.CancelPayments(PaymentStatus);
        enableSpinner(false);

        if (response?.paymentStatus?.length) await this.setState({ PaymentStatus: response.paymentStatus });
    }
    //#endregion

    //#region ########## PRINT DOCUMENTS & TICKETS ##########
    PrintDocuments = async (type, paperSize, order) => {
        let user = JSON.parse(localStorage.getItem("Timbra1currentUser"));
        let items = [];
        let payments = [];
        let payments2 = [];

        for (let index = 0; index < order.Items.length; index++) {
            items[index] = {
                ItemCode: order.Items[index].ItemCode || "",
                ItemName: (order.Items[index].ItemName ? order.Items[index].ItemName : order.Items[index].ItemDescription) || "",
                Price: (order.Items[index].Total ? (Number(order.Items[index].Total) / Number(order.Items[index].Quantity)).toFixed(2).toString() : order.Items[index].HomePrice ? Number(order.Items[index].HomePrice).toFixed(2).toString() : Number(order.Items[index].UnitPrice).toFixed(2).toString()) || "",
                Quantity: Number(order.Items[index].Quantity).toFixed(4).toString() || "",
                UM: order.Items[index].InvntryUom ? order.Items[index].InvntryUom : "" || ""
            }
        }

        if (order.hasOwnProperty("PaymentsToReturn")) {
            for (let index = 0; index < order.PaymentsToReturn.length; index++) {
                payments[index] = {
                    Payment: /*order.PaymentsToReturn[index].PM_Name ||*/ "",
                    Amount: order.PaymentsToReturn[index].Amount || "",
                    Ref: order.PaymentsToReturn[index].AcctCode || "",
                    Type: this.shortName(order.PaymentsToReturn[index].PM_Name) || "",
                    Account: order.PaymentsToReturn[index].PayAccountNum || order.PaymentsToReturn[index].PaycheckNum || order.PaymentsToReturn[index].PaymentAccountNum || order.PaymentsToReturn[index].TransferNum || "",
                }
            }
        }

        if (order.hasOwnProperty("PaymentsToSale")) {
            for (let index = 0; index < order.PaymentsToSale.length; index++) {
                payments2[index] = {
                    Payment: /*order.PaymentsToReturn[index].PM_Name ||*/ "",
                    Amount: order.PaymentsToSale[index].amount || "",

                    Type: this.shortTypeName(order.PaymentsToSale[index].typeMethod) || "",
                    Account: order.PaymentsToSale[index].PayAccountNum || order.PaymentsToSale[index].PaycheckNum || order.PaymentsToSale[index].PaymentAccountNum || order.PaymentsToSale[index].TransferNum || "",
                }
            }
        }

        let data = {
            Config: {
                TicketType: type,
                PaperSize: paperSize
            },
            Store: {
                Name: Datos_Empresa.Nombre + " " + Datos_Empresa.Sociedad,
                Address: user.Branch.Address || "",
                RFC: user.Timbra.RFC || "",
                Phone: user.Branch.Phone || "",
                Logo: "",
                Footer: "Sin más por el momento y en espera de vernos favorecidos, quedo de Usted para cualquier duda o aclaración. * Precios Sujetos a Cambio Sin Previo Aviso. ** Los precios arriba cotizados son para los volúmenes solicitados, por lo que al variar estos los precios pueden verse afectados.*** Maniobras de descarga a cargo del cliente. Toda cancelación o devolución sólo será efectiva presentando la nota y en un plazo no mayor a 7 días. Si se requiere factura, es en un plazo no mayor a 7 días, y/o en los casos que aplique, antes de cierre de mes.",
                Consecutive: order.next_Folio_Cons && order.next_Folio_Cons != "" ? order.next_Folio_Cons : order.NextFolio && order.NextFolio != "" ? order.NextFolio : !!order.docHeader && order.NextFolio != "" ? order.docHeader.infoByFolio.nextFolio : ""
            },
            BusinessPartner: {
                CardCode: order.CardCode || "",
                CardName: order.CardName || "",
                RFC: order.LicTradNum || user.Partner.LicTradNum || "",
                Regime: "PERSONA FÍSICA CON ACTIVIDAD EMPRESARIAL",
                Phone: user.Partner.Phone1 || "",
                AddressInvoice: (order.Address || "").toUpperCase() || "",
                AddressDelivery: (order.Address2 || "").toUpperCase() || "",
            },
            OrderSale: {
                DocNum: order.folio || "",
                DocDate: order.DocDate + " " + order.DocTime || "",
                DocOrigen: order.NextFolio || "XXXXX",
                Seller: (order.SlpName || "").substring(30, 0) || "",
                Cashier: user.USER_CODE || "",
                DocTotal: order.Total || "0.00",
                Subtotal: order.Subtotal || "0.00",
                TaxTotal: order.Taxes || "0.00",
                TaxRate: Math.trunc(Number(order.TaxRate || "")) || "",
                DocCur: order.DocCur || "",
                Items: items || "",
                Payments: payments || "",
                Payments2: payments2 || "",
            },
            CashCut: {
                Type: "",
                DocNum: "",
                DocDate: "",
                Cashier: "",
                DocTotal: "",
                DocCur: "",
                NumSales: "",
                NumReturns: "",
                NumCollects: "",
                TotalSale: "",
                TotalCash: "",
                TotalReturn: "",
                TotalCashIn: "",
                TotalCashOut: "",
                TotalCard: "",
                TotalTransfer: "",
                TotalCheck: "",
                TotalReturnAsPayment: "",
                TotalCredit: "",
                TotalCreditNote: "",
                TotalCollect: "",
                CashIns: [],
                CashOuts: [],
                Cards: [],
                Transfers: [],
                Checks: [],
                ReturnsAsPayment: [],
                Credits: [],
                CreditNotes: []
            }
        }
        data.Store.Logo = development == true ? "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"
            : Datos_Empresa.LogoBase64;

        await apiClient.PrintDocuments(data);
    };

    ShowCreatedAcuseReturn = async (folio) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let { newOrderModel } = this.state;
        newOrderModel.CashSum = 0;
        newOrderModel.TotalRestante = 0;
        let data = {
            docsToPrintIds: [folio],
            typeDoc: 14
        }
        enableSpinner(true);
        let responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            this.CloseCreatedInvoiceActions();
            return;
        }

        await this.setState({
            docsToPrint: responseApi.data ?? [],
            typeDocPrint: "ORIM",
            ordersToAction: folio,
            EnableEditButton: false,
            newOrderModel,
            itemSelected: {},
        });

        await this.ShowPDFViewer();
        $("#pdfViewer").modal("show");
    }

    ShowPDFViewer = async () => {
        await this.setState({ showPDFViewer: !this.state.showPDFViewer });
    }

    CloseCreatedInvoiceActions = async () => {
        let { isCancel, PointsCardModel } = this.state;

        await this.ShowPDFViewer();
        await this.setState({
            newOrderModel: new NewOrderSales(),
            docsToPrint: [],
            typeDocPrint: "",
            ordersToAction: 0,
            requireInvoice: false,
            itemSelected: {},
            extraDocsToShow: [],
            indexTypeDocShow: 0,
            ShowExtraActions: false
        })
        if (PointsCardModel && PointsCardModel.Customer && PointsCardModel.Customer.LostPoints && points_Card) {
            await this.setState({ showAreYouAgreeModal_Join_e_Wallet: !this.state.showAreYouAgreeModal_Join_e_Wallet, });
            $("#areYouAgreeModal").modal("show");
        }
    }

    CloseBillModal = async () => {
        await this.setState({
            showRefundModal: false,
            itemSelected: {},
            pedido: "",
            itsCancelCFDIAvailable: false,
            relatedDocs: [],
        });
    }

    ShowNextDocument = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { extraDocsToShow, indexTypeDocShow } = this.state;

        let indexDoc = indexTypeDocShow + 1;
        if (indexDoc === extraDocsToShow.length) {
            indexDoc = 0; // back to origin
        }

        const data = {
            docsToPrintIds: [extraDocsToShow[indexDoc].Folio],
            typeDoc: extraDocsToShow[indexDoc].DocObjectType
        }
        enableSpinner(true);
        let responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }

        for (let index = 0; index < responseApi.data.length; index++) {
            const document = responseApi.data[index];
            if (extraDocsToShow[indexDoc].timbraResponse && index === 0 && extraDocsToShow[indexDoc].timbraResponse.status) {
                if (extraDocsToShow[indexDoc].timbraResponse && index === 0 && extraDocsToShow[indexDoc].timbraResponse.status) {
                    // showAlert({ type: "success", message: `${extraDocsToShow[indexDoc].timbraResponse.message}` });
                    document.docHeader.responseHeader.U_FMB_XMLTIMBRA = JSON.stringify(extraDocsToShow[indexDoc].timbraResponse.XML);
                } else if (extraDocsToShow[indexDoc].timbraResponse && !extraDocsToShow[indexDoc].timbraResponse.status) {
                } else if (extraDocsToShow[indexDoc].timbraResponse && !extraDocsToShow[indexDoc].timbraResponse.status) {
                    showAlert({ type: "error", message: `Documento no timbrado` });
                    showAlert({ type: "info", message: `${extraDocsToShow[indexDoc].timbraResponse.message}`, timeOut: 10000 });
                }
            }
            await this.setState({
                docsToPrint: responseApi.data ?? [],
                typeDocPrint: extraDocsToShow[indexDoc].TypeDoc,
                EnableEditButton: false,
                indexTypeDocShow: indexDoc
            });
        }
    }

    ShowFormatToPrint = async () => {
        await this.setState({
            printhide: !this.state.printhide,
        });
    };

    RefreshDocModel = async (EditableDocModel) => {
        await this.setState({ EditableDocModel })
    }

    UploadInvoice = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ordersToAction, idWorkShift, newOrderModel } = this.state;
        const pedido = this.state.isAuthorization ? this.state.relatedFolio : this.state.pedido;

        let infoFolio = await _generalFunctions.getDocInfoByFolio(pedido)
        let data = {
            ordersToAction,
            infoFolio,
            idWorkShift,
            newOrderModel,
            Folio: pedido,
            Time: moment().format(),
        }

        enableSpinner(true);
        let responseApi = await apiClient.createInvoiceCounter(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        showAlert({ type: "success", message: `${responseApi.message}`, timeOut: 10000 });
        await this.CloseRefundModal()
        $("#salesModal").modal("hide");
        await this.ShowCreatedInvoice(responseApi.data.createdFolio, false, responseApi.data.timbraResponse);
    }

    CloseRefundModal = async () => {
        let { newOrderModel } = this.state;

        newOrderModel = new NewOrderSales();

        await this.setState({
            newOrderModel,
            showRefundModal: false,
            itemSelected: {},
            pedido: "",
            itsCancelCFDIAvailable: false,
            relatedDocs: [],
            isAuthorization: false,
            relatedFolio: "",
        });
        await this.CheckWorkSession();
        await this.SetBranchOfficeInfo();
    };

    ShowCreatedInvoice = async (document, beforeEdit, timbraResponse = null) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        if (!beforeEdit) {
            const data = {
                docsToPrintIds: [document],
                typeDoc: 13
            }
            enableSpinner(true);
            const responseApi = await apiClient.getPrintDocsInfo(data);
            enableSpinner(false);
            if (responseApi.status !== 1) {
                showAlert({ type: "error", message: `${responseApi.message}` });
                this.CloseCreatedInvoiceActions();
                return;
            }

            for (let index = 0; index < responseApi.data.length; index++) {
                const document = responseApi.data[index];
                if (timbraResponse && index === 0 && timbraResponse.status) {
                    showAlert({ type: "success", message: `${timbraResponse.message}` });
                    document.docHeader.responseHeader.U_FMB_XMLTIMBRA = JSON.stringify(timbraResponse.XML);
                } else if (timbraResponse && !timbraResponse.status) {
                    showAlert({ type: "error", message: `Documento no timbrado` });
                    showAlert({ type: "info", message: `${timbraResponse.message}`, timeOut: 10000 });
                }
            }

            await this.setState({
                docsToPrint: responseApi.data ?? [],
                typeDocPrint: "OINV",
                ordersToAction: document,
                EnableEditButton: false,
                showPDFViewer: !this.state.showPDFViewer,
                ShowExtraActions: timbraResponse && timbraResponse.status ? true : false
            });

            $("#pdfViewer").modal("show");
        } else {
            await this.setState({
                docsToPrint: [document] ?? [],
                typeDocPrint: "OINV",
                ordersToAction: ""
            });
            await this.ShowPDFViewer();
            $("#pdfViewer").modal("show");
        }
    }
    //#endregion

    //#region CANCELACION DE CFDI DE TARJETA DE PUNTOS 
    CancelPaymentPointsCard = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { relatedIncomingPayments } = this.state;

        if (!relatedIncomingPayments?.relatedPayments?.length) return showAlert({ type: "warning", message: `Sin documentos por cancelar`, timeOut: 8000 });

        enableSpinner(true);
        let relatedIncomingPay = this.state.relatedIncomingPayments?.relatedPayments;

        for (let index = 0; index < relatedIncomingPay.length; index++) {
            const element = relatedIncomingPay[index];
            element.ObjType = 24;
            element.Status = 1;
        }

        let response = await apiClient.CancelPayments(relatedIncomingPay);
        if (response.status !== 1) {
            enableSpinner(false);
            return showAlert({ type: "error", message: response.message });
        }

        for (let index = 0; index < response.paymentStatus.length; index++) {
            const returnPayment = response.paymentStatus[index];
            showAlert({ type: "info", message: 'Pago' + returnPayment.DocNum + ' Cancelado correctamente' });

            if (returnPayment.Status === -1) {
                this.setState({
                    relatedIncomingPayments: {
                        relatedPayments: [],
                        isCanceledPayment: true,
                    },
                    flagIfDocPointsCard: true,
                    ifExistPayment: false,
                })
            }
        }

        enableSpinner(false);

        if (this.state.flagIfDocPointsCard) {
            $('#notificationPointsCard').modal('show');
        }
    };

    CloseShowAreYouAgreeModal = async () => {
        await this.setState({
            ifExistPayment: false,
            flagIfDocPointsCard: false,
        });
    };

    cancelTimbra = async (dataDocs) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { info, Table } = dataDocs;

        showAlert({ type: "info", message: 'Se esta cancelando el TIMBRE de la ' + (Table === "OINV" ? 'Factura ' : 'Nota de crédito ') + info.DocNum, timeOut: 11000 })

        // CONSULTAR STATUS
        const data = {
            DocEntry: info.DocEntry,
            Table: {
                name: Table,
            }
        }
        enableSpinner(true);
        let response = await apiClient.ConsultarEstatusCFDI(data);
        enableSpinner(false);

        let resultado = {
            status: 0,
        }
        if (response.status === 1) { //Documento cancelado
            // this.setState({
            //     isCancel: true,
            // })
            showAlert({ type: "success", message: `${info.DocNum || ''}: ${response.message ?? ""}`, timeOut: 8000 });
            return resultado;
        } else if (response.status === 2) { //Cancelable 
            // SE MANDA A CANCELAR EN AUTOMATICO EL CFDI DEL DOCUMENTO
            // this.setState({
            //     isValidCFDI: true,
            // })
            showAlert({ type: "info", message: `${info.DocNum || ''}: ${response.message ?? ""}`, timeOut: 8000 });
            let resultado = await this.CancelCFDIPointsCard(data)
            return resultado;
        } else {
            showAlert({ type: "warning", message: `${info.DocNum || ''}: ${response.message ?? ""}`, timeOut: 8000 });
            return resultado;
        }
    };

    CancelCFDIPointsCard = async (info) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        const data = {
            DocEntry: info.DocEntry,
            Table: {
                name: info.Table.name,
            },
            Motivo: "03",
            U_FMB_UUID_RELACIONADO: "",
        }

        enableSpinner(true);
        const response = await apiClient.CancelCFDI(data);
        enableSpinner(false);

        if (response.status === 0) {
            showAlert({ type: "error", message: `${response.message ?? ""}`, timeOut: 10000 });
            return response;
        } else if (response.status === 2) {
            showAlert({ type: "info", message: `${response.message ?? ""}`, timeOut: 10000 });
            return response;
        } else {
            // if (info.Table.name === "OINV") {
            //     await this.setState(prevState => ({
            //         headerDocument: {
            //             ...prevState.headerDocument,
            //             IsCancelCFDI: "Y"
            //         }
            //     }));
            // } else if (info.Table.name === "ORIN") {
            //     await this.setState(prevState => ({
            //         relatedDocs: prevState.relatedDocs.map((doc, index) =>
            //             index === 0 ? { ...doc, IsCancelCFDI: "Y" } : doc
            //         )
            //     }));
            // }
            showAlert({ type: "success", message: `${response.message ?? ""}`, timeOut: 10000 });
            return response;
        }
    };

    returnPointsCard = async (info) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        const response = await apiClient.returnPointsCard(info);
        enableSpinner(false);

        if (response.status === 0) {
            showAlert({ type: "error", message: `${response.message ?? ""}`, timeOut: 8000 });
            return;
        }
        await this.setState({
            returnedPoints: response.data[0].RESULT || 0,
        })

    }
    //#endregion

    //#region ########## RETURNS & CANCELATIONS #############
    SearchSale = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { pedido, _user } = this.state;

        if (!pedido) {
            showAlert({ type: "warning", message: `No ha ingresado un documento a consultar`, timeOut: 5000 });
            return;
        }

        let infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);
        const data = {
            Folio: pedido,
            infoFolio,
        };

        enableSpinner(true);
        const responseSales = await apiClient.getSaleDocuments(data);
        enableSpinner(false);
        if (responseSales.status !== 1) {
            if (responseSales.status === 2) { showAlert({ type: "succes", message: "Docuemnto recuperado" }); }
            else {
                await this.setState({ checkboxDataTables: (new Map()) });
                await this.CloseRefundModal();
                return showAlert({ type: responseSales.status === 3 ? "info" : "error", message: responseSales.message });
            }
        }

        if (responseSales?.status === 1 && responseSales?.data?.ourInfo?.folio && infoFolio?.isElectronic) {
            infoFolio = await _generalFunctions.getDocInfoByFolio(responseSales?.data?.ourInfo?.folio);

        }
        if (responseSales.data.ourInfo && responseSales.data.ourInfo.folio && _user?.Branch.CodeBranchOffice !== infoFolio.codeBO) {
            await this.setState({
                checkboxDataTables: (new Map()),
            });
            await this.CheckWorkSession();
            await this.SetBranchOfficeInfo();
            showAlert({ type: "warning", message: `LA DEVOLUCIÓN O CANCELACIÓN NO PODRÁ SER PROCESADA. ESTE FOLIO PERTENECE A OTRA SUCURSAL.`, timeOut: 50000 });
            return
        }
        if (responseSales.data.headerDocument.valuePointsCard === 'C' && points_Card) {
            showAlert({ type: "warning", message: `Este documento pertenecía a una compra con monedero, la cual ya ha sido devuelta.`, timeOut: 15000 });
            return
        }

        const ItsReserveInvoice = responseSales.data.headerDocument.isIns === "Y" ? true : false;
        const createdFromReserve = (responseSales.data.headerDocument.U_FMB_CREATEDFROM && responseSales.data.headerDocument.U_FMB_CREATEDFROM !== null && Number(responseSales.data.headerDocument.U_FMB_CREATEDFROM) === 0) ? true : false;
        const itsCancelCFDIAvailable = !!responseSales.data.headerDocument.U_FMB_NUM_CERTIFICADO && responseSales.data.headerDocument.U_FMB_NUM_CERTIFICADO !== null ? true : false;

        if (createdFromReserve) showAlert({ type: "info", message: `ENTREGA DE FACTURA DE RESERVA DETECTADA. NO ES POSIBLE GENERAR DEVOLUCIONES NI CANCELACIONES`, timeOut: 50000 });

        const ItsCreditInvoice = responseSales.data.relatedPayMethods.find(element => Number(element.typeMethod) === -1);
        const needRelation = ((infoFolio.folioID === "IV" && ItsCreditInvoice)) ? true : false;
        const OrderSale = await this.FillInfoReturns(responseSales.data.headerDocument, needRelation, responseSales.data.relatedPayMethods, ItsReserveInvoice, responseSales?.status === 2, responseSales?.data?.userFieldsItemsDocument);

        await this.RefreshReturnTotal(OrderSale);
        if (responseSales.data.relatedDocs && responseSales.data.relatedDocs.length > 0) {
            const related = responseSales.data.relatedDocs[0].NumAtCard;

            if (related && related.substring(3, 5) === "AP" && points_Card) {
                showAlert({ type: "info", message: `Este documento pertenece a una venta realizada con monedero electrónico.`, timeOut: 15000 });
                let flagReturnPointsCard = true;
                await this.setState({
                    flagIfDocPointsCard: true
                })
                if (responseSales.data.relatedIncomingPayments?.relatedPayments[0]?.DocNum) {
                    await this.setState({
                        ifExistPayment: true,
                        flagIfDocPointsCard: false,
                    })
                }
                if (responseSales.data.headerDocument?.DocStatus === 'O' || responseSales.data.relatedDocs[0]?.DocStatus === 'O') {
                    flagReturnPointsCard = false;
                }
                if (responseSales.data.headerDocument?.DocStatus === 'C' && responseSales.data.headerDocument?.CANCELED === 'Y' && responseSales.data.headerDocument?.IsCancelCFDI === 'N') {
                    let resul = await this.cancelTimbra({ Table: 'OINV', info: responseSales.data.headerDocument });
                    if (resul.status === 1) {
                        responseSales.data.headerDocument.IsCancelCFDI = "Y";
                        flagReturnPointsCard = true;
                    }
                }

                if (responseSales.data.headerDocument?.DocStatus === 'O' || responseSales.data.relatedDocs[0]?.DocStatus === 'O') {
                    flagReturnPointsCard = false;
                }

                if (responseSales.data.relatedDocs[0]?.DocStatus === 'C' && responseSales.data.relatedDocs[0]?.CANCELED === 'Y' && responseSales.data.relatedDocs[0]?.IsCancelCFDI === 'N') {
                    let resul = await this.cancelTimbra({ Table: 'ORIN', info: responseSales.data.relatedDocs[0] });
                    if (resul.status === 1) {
                        responseSales.data.relatedDocs[0].IsCancelCFDI = "Y";
                        flagReturnPointsCard = true;
                    }
                }
                // FUNCION PARA REGRESAR LOS PUNTOS Y CERRAR EL DOCUMENTO
                if (flagReturnPointsCard) {
                    await this.returnPointsCard(responseSales.data.headerDocument);
                }
            }
            let message = infoFolio.folioID === "IV" ? `ESTA FACTURA ESTA LIGADA A LA NOTA DE CRÉDITO CON FOLIO:  ${related}` : (infoFolio.folioID === "DL" || infoFolio.folioID === "DH") ? `ESTA ENTREGA ESTA LIGADA A LA DEVOLUCIÓN CON FOLIO:  ${related}` : "";
            showAlert({ type: "info", message: `Este documento ya sufrió un cambio. ${message}`, timeOut: 10000 });
            await this.setState({
                canCancelDocument: true
            })
            if (OrderSale.Items.length > 0) {
                if (responseSales?.data?.action && responseSales?.data?.action !== "refund") { this.CloseRefundModal(); return showAlert({ type: "info", message: `No es posible cancelar un documento que ya cuenta con devoluciones`, timeOut: 10000 }); }
                showAlert({ type: "info", message: `Solo se recuperaron las lineas abiertas`, timeOut: 10000 });
            } else {
                await this.setState({
                    newOrderModel: new NewOrderSales(),
                    checkboxDataTables: (new Map()),
                });
                await this.CheckWorkSession();
                await this.SetBranchOfficeInfo();
                return showAlert({ type: "info", message: `Este documento ya no cuenta con lineas abiertas`, timeOut: 10000 });
            }
        } else {
            await this.setState({
                canCancelDocument: false
            })
        }

        if (responseSales.data.relatedPayMethods && responseSales.data.relatedPayMethods.length > 0) {
            await this.setState({
                relatedPayMethodsByDoc: responseSales.data.relatedPayMethods || []
            })
            // check if the doc its for credit
            if (ItsCreditInvoice) {
                if (responseSales.data.collectData !== null) {
                    OrderSale.OutstandingBalance = responseSales.data.collectData.totalPago || 0;
                    OrderSale.AbonadoTotal = responseSales.data.relatedIncomingPayments.relatedPaymentsTotal || 0;
                    OrderSale.payWasCanceled = responseSales.data.ourInfo.paidOut || "N";
                }

                await this.setState({
                    AvailablePayments: responseSales.data.relatedIncomingPayments.paymentsSOS1 || [],
                    ItsCreditInvoice: true,
                })
            } else {
                await this.setState({
                    ItsCreditInvoice: false,
                })
            }
        }

        for (let index = 0; index < OrderSale.Items.length; index++) {
            const element = OrderSale.Items[index];
            element.OnHand = Number(element.OnHand || 0);
            element.SWeight1 = Number(element.SWeight1 || 0);
            if (responseSales?.status !== 2) { element.newQuantity = 0; }
        }
        let actionSale = responseSales?.data?.action || "";
        if (actionSale) actionSale = actionSale === "refund" ? "refund" : (responseSales.data.relatedDocs.length === 0 ? (itsCancelCFDIAvailable ? "cancel" : "cancelSale") : "");

        await this.setState({
            newOrderModel: OrderSale,
            // newOrderModel.PaymentsToSale: responseSales.data.relatedPayMethods,
            ourInfoForReturn: responseSales.data.ourInfo || "",
            infoCondiPagoReturn: responseSales.data.infoCondiPago || "",
            relatedIncomingPayments: responseSales.data.relatedIncomingPayments || "",
            checkboxDataTables: (new Map()),
            ItsReturnBill: infoFolio.folioID !== "IV" ? true : false,
            ItsReserveInvoice: ItsReserveInvoice,
            createdFromReserve: createdFromReserve,
            itsCancelCFDIAvailable: itsCancelCFDIAvailable,
            relatedDocs: responseSales.data.relatedDocs || [],
            isAuthorization: responseSales?.status === 2,
            relatedFolio: responseSales?.data?.U_FMB_RelatedFolio || "",
            actionSale,
            headerDocument: responseSales.data.headerDocument || {},
        });
        if (this.state.flagIfDocPointsCard) {
            $('#notificationPointsCard').modal('show');
        }
        if (this.state.ifExistPayment) {
            $("#areYouAgreeModal").modal("show");
        }
    }

    FillInfoReturns = async (response, needRelated, payments, ItsReserveInvoice = false, isAuthorization, userFieldsItemsDocument = []) => {
        const { _user } = this.state;
        const pedido = this.state.isAuthorization ? this.state.relatedFolio : this.state.pedido;
        let OrderModel = new NewOrderSales();
        let infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);

        OrderModel.CardCode = response.CardCode;
        OrderModel.CardName = response.CardName;
        OrderModel.SlpCode = response.SlpCode;
        OrderModel.ObjType = response.ObjType;
        OrderModel.NextFolio = response.NumAtCard;
        OrderModel.DocStatus = response.DocStatus;
        OrderModel.ReceiptNum = response.ReceiptNum;
        OrderModel.DocTotal = response.DocTotal;
        OrderModel.PaymentsToSale = [] //payments
        OrderModel.VatSum = Number(response.VatSum) || 0;
        OrderModel.LicTradNum = response.LicTradNum ?? "";

        // direcciones del documento base
        if (response.AddressExtension) OrderModel.AddressExtension = await this.FillAddressesUpdatePartner(response.AddressExtension, "", true);

        if (needRelated) {
            OrderModel.DocEntry = response.DocEntry || "";
        }
        //#region ########## DOCUMENTOS RELACIONADOS ORIN ######################
        OrderModel.U_UDF_UUID = response.U_UDF_UUID || "";
        // newIntegration
        OrderModel.USOCFDI = response.U_FMB_USO_CFDI || "";
        //#endregion

        //#region CUFD
        OrderModel.U_RS_SOLAPR = 'N';
        //#endregion CUFD

        let auxItemsArray = [];
        for (let i = 0; i < response.Items.length; i++) {
            const ItemRes = response.Items[i];
            let newItemModel = new NewItem();
            let userFieldsItems = new UserFieldsItem();
            if (needRelated) {
                newItemModel.BaseEntry = response.DocEntry || "";
                newItemModel.BaseType = infoFolio.folioID === "DL" ? 15 : infoFolio.folioID === "IV" ? 13 : -1;
                newItemModel.BaseLine = (ItemRes.LineNum || ItemRes.LineNum === 0) ? ItemRes.LineNum : "";
            }
            // it is if the reserveInvoice Base doc the BackEnd create his delivery after create a CreditNote
            if (ItsReserveInvoice) {
                newItemModel.AuxBaseEntry = response.DocEntry || "";
                newItemModel.AuxBaseType = 13;
                newItemModel.AuxBaseLine = ItemRes.LineNum ?? "";
            }

            try {
                json.allItemsUserFields.map((itemField, index) => {
                    userFieldsItemsDocument.map((userfieldItem) => {
                        if (itemField.fieldId == userfieldItem.header.FieldID) {
                            itemField.name = userfieldItem.header.Descr;
                            itemField.fieldType = userfieldItem.options.length != 0 ? 2 : 1;
                            itemField.options = userfieldItem.options;
                            itemField.IdValue = index;
                            let newUserFields = this.setUserFieldItemsValue(userFieldsItems, index, ItemRes);
                            if (itemField.fieldType === 2) {
                                itemField.options.push({ FldValue: "", Descr: "" });
                            }
                            userFieldsItems = newUserFields;
                        }
                    });
                });
                newItemModel.UserFieldsItem = userFieldsItems;
            } catch (error) {
            }

            newItemModel.LineStatus = ItemRes.LineStatus === "O" ? true : false;
            newItemModel.LineNum = ItemRes?.LineNum ?? "";
            newItemModel.ItemCode = ItemRes.ItemCode;
            newItemModel.ItemName = ItemRes.ItemName !== undefined && ItemRes.ItemName !== "" ? ItemRes.ItemName : ItemRes.Dscription;
            newItemModel.Description = ItemRes.Dscription
            newItemModel.PicturName = ItemRes.PicturName;
            newItemModel.UserText = ItemRes.UserText;
            newItemModel.CodeBars = ItemRes.CodeBars || "";
            newItemModel.HomePrice = Number(ItemRes.Price);
            newItemModel.Price = Number(ItemRes.Price);
            newItemModel.VatSum = Number(ItemRes.ImpuestoRow);
            newItemModel.Total = Number(ItemRes.LineTotal)
            newItemModel.TaxCode = ItemRes.TaxCode;
            newItemModel.TaxRate = ItemRes.Impuesto;
            newItemModel.NumInSale = Number(ItemRes.NumInSale || 0);
            newItemModel.OnHand = Number(ItemRes.OnHand || 0);
            newItemModel.Quantity = Number(ItemRes.Quantity || 1);
            newItemModel.newQuantity = Number(ItemRes.Quantity || 1);
            newItemModel.RevenuesAc = ItemRes.RevenuesAc;
            newItemModel.WhsCode = !infoFolio?.isElectronic ? _user?.Branch.ProjectCode : ItemRes?.WhsCode;
            newItemModel.SWeight1 = Number(ItemRes.SWeight1 || 0);
            newItemModel.SWght1Unit = ItemRes.SWght1Unit || 3;
            newItemModel.InvntItem = ItemRes.InvntItem || "Y";
            newItemModel.ManBtchNum = ItemRes.ManBtchNum || "M";
            newItemModel.Discount = ItemRes.Descuento || 0;
            newItemModel.PriceBefDi = ItemRes.PriceBefDi || 0;
            newItemModel.OpenQty = ItemRes.OpenQty ? ItemRes.OpenQty : 0;
            newItemModel.AvgPrice = ItemRes.AvgPrice || 0;

            // batch selection was changed to manually selection for errores in this automatization 
            // if (ItemRes.BatchNumbers) {
            //     let auxBatchObject = ItemRes.BatchNumbers[0] || null;
            //     if (auxBatchObject !== null) {
            //         auxBatchObject.Quantity = "0";
            //     }
            //     ItemRes.BatchNumbers = auxBatchObject !== null ? [auxBatchObject] : [];
            //     newItemModel.BatchNumbers = ItemRes.BatchNumbers ?? [];
            // }
            newItemModel.BatchNumbers = [];
            //#region CENTROS DE COSTOS

            //CENTRO DE COSTO 1
            newItemModel.OcrCode = ItemRes.OcrdCode || "";
            //CENTRO DE COSTO 2
            newItemModel.OcrCode2 = OrderModel.OcrCode2 || "";
            //CENTRO DE COSTO 3
            newItemModel.OcrCode3 = ItemRes.OcrCode3 || "";
            //CENTRO DE COSTO 4
            newItemModel.OcrCode4 = ItemRes.OcrCode4 || "";
            //CENTRO DE COSTO 5
            newItemModel.OcrCode5 = ItemRes.OcrCode5 || "";

            //#endregion CENTROS DE COSTOS

            //#region CUFD
            newItemModel.U_BPP_OPER = ItemRes.U_BPP_OPER || "-";
            newItemModel.U_STR_FECodAfect = ItemRes.U_STR_FECodAfect || '';
            //#endregion CUFD

            auxItemsArray.push(newItemModel);

            // Nueva versión de devoluciones
            newItemModel.InvntSttus = (!ItemRes.InvntSttus || ItemRes?.InvntSttus === "C") ? true : false;
            newItemModel.AuxLineNum = ItemRes?.AuxLineNum ?? "";

        }
        OrderModel.Items = auxItemsArray ?? [];

        return OrderModel;
    }

    FillAddressesUpdatePartner = async (AddressExt, ShipToCode = "", returnDoc = false) => {
        const { newOrderModel } = this.state
        if (returnDoc) { // specially if for returns documents
            //SHIP
            let AuxAddressExtension = {};
            AuxAddressExtension.ShipToStreet = AddressExt.ShipToStreet || "";
            AuxAddressExtension.ShipToBlock = AddressExt.ShipToBlock || "";
            AuxAddressExtension.ShipToCity = AddressExt.ShipToCity || "";
            AuxAddressExtension.ShipToZipCode = AddressExt.ShipToZipCode || "";
            AuxAddressExtension.ShipToCounty = AddressExt.ShipToCounty || "";
            AuxAddressExtension.ShipToCountry = AddressExt.ShipToCountry || "";
            AuxAddressExtension.ShipToState = AddressExt.ShipToState || "";

            AuxAddressExtension.BillToStreet = AddressExt.BillToStreet || "";
            AuxAddressExtension.BillToBlock = AddressExt.BillToBlock || "";
            AuxAddressExtension.BillToCity = AddressExt.BillToCity || "";
            AuxAddressExtension.BillToZipCode = AddressExt.BillToZipCode || "";
            AuxAddressExtension.BillToCounty = AddressExt.BillToCounty || "";
            AuxAddressExtension.BillToCountry = AddressExt.BillToCountry || "";
            AuxAddressExtension.BillToState = AddressExt.BillToState || "";
            const auxExtension = Object.assign({}, AuxAddressExtension)
            // await this.refreshModel(newOrderModel)
            return auxExtension;
        } else {
            if (ShipToCode !== "" && (newOrderModel.ShipToCode === "" || newOrderModel.ShipToCode === null || newOrderModel.ShipToCode === undefined)) {
                newOrderModel.ShipToCode = ShipToCode || "";
            }
            //SHIP
            newOrderModel.AddressExtension.ShipToStreet = AddressExt.StreetS || "";
            newOrderModel.AddressExtension.ShipToBlock = AddressExt.BlockS || "";
            newOrderModel.AddressExtension.ShipToCity = AddressExt.CityS || "";
            newOrderModel.AddressExtension.ShipToZipCode = AddressExt.ZipCodeS || "";
            newOrderModel.AddressExtension.ShipToCounty = AddressExt.CountyS || "";
            newOrderModel.AddressExtension.ShipToCountry = AddressExt.CountryS || "";
            newOrderModel.AddressExtension.ShipToState = AddressExt.StateS || "";
            //BILL
            newOrderModel.AddressExtension.BillToStreet = AddressExt.StreetB || "";
            newOrderModel.AddressExtension.BillToBlock = AddressExt.BlockB || "";
            newOrderModel.AddressExtension.BillToCity = AddressExt.CityB || "";
            newOrderModel.AddressExtension.BillToZipCode = AddressExt.ZipCodeB || "";
            newOrderModel.AddressExtension.BillToCounty = AddressExt.CountyB || "";
            newOrderModel.AddressExtension.BillToCountry = AddressExt.CountryB || "";
            newOrderModel.AddressExtension.BillToState = AddressExt.StateB || "";
            await this.refreshModel(newOrderModel)
        }
    }

    ValidateCloseDocument = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { ourInfoForReturn, createdFromReserve, newOrderModel } = this.state;
        if (!ourInfoForReturn) return showAlert({ type: "warning", message: `AUN NO HAS BUSCADO LA INFORMACIÓN DE ESTE DOCUMENTO, PRESIONA LA LUPA PARA BUSCAR LA INFORMACIÓN Y CONTINUAR` });
        if (createdFromReserve) return showAlert({ type: "info", message: `ENTREGA DE FACTURA DE RESERVA. NO ES POSIBLE GENERAR CANCELACIONES` });

        if (ourInfoForReturn?.paidOut === "Y") {
            newOrderModel.Items.forEach((item) => {
                item.Quantity = item.OpenQty;
                item.newQuantity = item.OpenQty;
                item.OpenLneQty = item.OpenQty;
            })

            const successCode = async () => {
                await this.setState({ ShowRefundOfPaymentsModal: true });
                $("#refundOfPaymentsModal").modal("show");
                $("#refundOfPaymentsModal").on("hidden.bs.modal", async () => {
                    await this.setState({ ShowRefundOfPaymentsModal: false });
                });
            }

            await this.IntegrateBatchReturnDocs(successCode, "newQuantity")
            newOrderModel.AuxViewCounter = "RefundModal";
            this.refreshModel(newOrderModel)
        } else {
            showAlert({ type: "info", message: `TU DOCUMENTO NO ESTA PAGADO SE ESTA GENERANDO LA INVERSA AL DOCUMENTO INGRESADO. NOTA DE CREDITO SI INGRESASTE UNA FACTURA O DEVOLUCIÓN SI ERA UNA VENTA `, timeOut: 5000 });
            await this.CloseDocument();
        }
    }

    IntegrateBatchReturnDocs = async (blockOfCodeSuccess = null, itemPropToUse) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, ShowRefundOfPaymentsModal } = this.state
        let itemsBatch = newOrderModel.Items.filter((item) => item.ManBtchNum === "Y");
        if (itemsBatch.length > 0) {
            let isBatchComplete = true;
            for (let index = 0; index < itemsBatch.length; index++) {
                const item = itemsBatch[index];
                item.SnBUoMQty = 0;
                for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                    const batch = item.BatchNumbers[indez];
                    item.SnBUoMQty += Number(batch[itemPropToUse]);
                }
                if (Number(item.SnBUoMQty) !== Number(item[itemPropToUse])) {
                    isBatchComplete = false;
                }
            }
            if (!isBatchComplete) {
                let itemCode = {};
                let whs = {}
                itemsBatch.sort((a, b) => {
                    if (a.ItemCode > b.ItemCode) {
                        return 1;
                    } else if (b.ItemCode > a.ItemCode) {
                        return -1;
                    } else {
                        if (a.WhsCode > b.WhsCode) {
                            return 1;
                        } else if (b.WhsCode > a.WhsCode) {
                            return -1;
                        } else {
                            return 0;
                        }
                    }
                });
                itemsBatch = itemsBatch.filter((item) => {
                    if (itemCode[item.ItemCode] && whs[item.WhsCode]) {
                        return false
                    } else {
                        itemCode[item.ItemCode] = true;
                        whs[item.WhsCode] = true;
                        return true;
                    }
                });
                let newItemsBatchArray = []
                for (let index = 0; index < itemsBatch.length; index++) {
                    const item = itemsBatch[index];
                    newItemsBatchArray.push({ ItemCode: item.ItemCode, WhsCode: item.WhsCode })
                }
                enableSpinner(true);
                let batchsResponse = await apiClient.getBatchItems({ newItemsBatchArray });
                enableSpinner(false);

                if (batchsResponse.status === 0) {
                    showAlert({ type: "error", message: `Ocurrió un error al consultar Lotes`, timeOut: 8000 });
                    return;
                }
                let isNewBatch = false;
                for (let index = 0; index < newOrderModel.Items.length; index++) {
                    const item = newOrderModel.Items[index];
                    for (let index = 0; index < batchsResponse.data.length; index++) {
                        const itemBatch = batchsResponse.data[index];
                        if (item.ItemCode === itemBatch.ItemCode && item.WhsCode === itemBatch.WhsCode) {
                            if (itemBatch.AvailableBatchNumbers && itemBatch.AvailableBatchNumbers.length > 0) {
                                isNewBatch = true;
                            }
                            item.AvailableBatchNumbers = itemBatch.AvailableBatchNumbers;
                        }
                    }
                }

                if (isNewBatch) {
                    await this.setState({
                        newOrderModel,
                        showBatchSelectionModal: true,
                    });
                    $("#batchSelectionModal").modal("show");
                    await this.RefreshReturnTotal(newOrderModel);
                    if (!ShowRefundOfPaymentsModal) {
                        await this.EnableShowRefundOfPaymentsModal();
                    }
                } else {
                    showAlert({ type: "error", message: `Ocurrió un error al consultar Lotes`, timeOut: 8000 });
                    return;
                }

            } else {
                if (blockOfCodeSuccess !== null) blockOfCodeSuccess();
            }
        } else {
            if (blockOfCodeSuccess !== null) blockOfCodeSuccess();
        }


    }

    CloseDocument = async (authorization = false) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idWorkShift, newOrderModel, ourInfoForReturn, ItsReserveInvoice, AuthorizationComments } = this.state
        const pedido = this.state.isAuthorization ? this.state.relatedFolio : this.state.pedido;
        const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);

        // GET SERIES FOR DOCUMENTS
        newOrderModel.SerieCN = await this.GetSeriesByCurrentUserProp("U_FMB_ValidateSeriesORIN");
        newOrderModel.SerieRT = await this.GetSeriesByCurrentUserProp("U_FMB_ValidateSeriesORDN");
        newOrderModel.SerieDL = await this.GetSeriesByCurrentUserProp("U_FMB_ValidateSeriesODLN");
        newOrderModel.OriginDoc = "Counter-CloseDocument";
        newOrderModel.idSession = idWorkShift;
        const data = {
            DocFolio: pedido,
            InfoFolio: infoFolio,
            idWorkShift: idWorkShift,
            ItsOriginDocClose: newOrderModel.DocStatus === "C" ? true : false,
            Time: moment().format(),
            newOrderModel,
            ItsNotPayed: ourInfoForReturn.paidOut === "N" ? true : false,
            ItsReserveInvoice: ItsReserveInvoice,
            ClientVersion: currentVersion,
            Authorization: authorization,
            comments: AuthorizationComments,
        }

        enableSpinner(true);
        const responseApi = await apiClient.ReturnDocument(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            if (responseApi.status === 2) {
                showAlert({ type: "info", message: responseApi.message, timeOut: 8000 });
                let document = responseApi.data.serviceLayeResponse;
                let folio = responseApi.data.createdFolio;

                newOrderModel.DocNum = document.DocNum;
                newOrderModel.DocTime = document.DocTime;
                newOrderModel.DocEntry = document.DocEntry;
                newOrderModel.folio = folio;
                newOrderModel.NumAtCard = '';
                newOrderModel.RecoverIdSale = '';
                newOrderModel.Comments = '';
                newOrderModel.PaymentsToSale = [];
                newOrderModel.Items = [];
                newOrderModel.Total = 0;

                await this.setState({
                    showBillModal: false,
                    newOrderModel,
                    isCancel: false,
                    disableRecover: false,
                    DownPayments: [],
                    CreditNotes: [],
                    showRefSaleModal: !this.state.showRefSaleModal,
                    showBatchSelectionModal: false,
                    FailedRequestDocument: true,
                    WasUpdatedPartner: false,
                    editModePartner: false,
                    ItsComingFromModifiedPartner: false,
                    RelatedPayMethodsByDoc: [],
                    itsInterOpDoc: false,
                    recoverDocument: false,
                    ItsRecoverAuthoriInvoice: false,
                    recoverInterOpTypeDoc: '',
                    updatebusinessPartner: new BusinessPartnerPS(),
                    auxRecoverDocData: null,
                    showTemporalData: false,
                });
                $("#refSaleModal").modal("show");
                return;
            }
            return showAlert({ type: "error", message: `${responseApi.message}` });
        }

        showAlert({ type: "success", message: `${responseApi.message}` });

        await this.setState({
            ordersToAction: 0,
            ordersDocs: [],
            ordersSearchModel: {
                CardCode: "",
                DocNum: "",
            },
        })

        if (infoFolio.folioID === "IV") { // facturas  
            this.ShowCreatedAcuseReturn(responseApi.data.createdFolio);
        } else if (infoFolio.folioID === "DL" || infoFolio.folioID === "DH") { //entregas normales y domicilio
            if ((infoFolio.folioID === "DH") && (ourInfoForReturn.paidOut && ourInfoForReturn.paidOut === "N")) {
                showAlert({ type: "success", message: `Cancelación exitosa.` });
            } else {
                this.ShowCreatedDevolutionDoc(responseApi.data.createdFolio);
            }
        }

        await this.setState({
            newOrderModel: new NewOrderSales(),
            checkboxDataTables: (new Map()),
            newOrderModelCopia: new NewOrderSales(),
            pedido: "",
            ShowRefundOfPaymentsModal: false,
        });
    }

    Devolver = async (validReturn = true, authorization = false) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, idWorkShift, newOrderModelCopia, _user, infoCondiPagoReturn, ourInfoForReturn, actionSale, ItsReserveInvoice, AuthorizationComments, relatedFolio } = this.state;
        const pedido = this.state.isAuthorization ? relatedFolio : this.state.pedido;
        if (actionSale === "cancelSale") { // TO PASS A CANCELLATION ACTION AS A NORMAL RETURN ACTION
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                let item = newOrderModel.Items[index];
                item.newQuantity = item.OpenQty;
            }
        }
        await this.setState({
            showrefund: true
        });
        let ObjType = "";
        let series = "";
        let newItems = [];
        let today = moment(new Date()).format("YYYY-MM-DD");

        if (infoCondiPagoReturn === undefined && infoCondiPagoReturn === "") {
            showAlert({ type: "info", message: "NO SE PUEDE DETERMINAR CUAL FUE EL MÉTODO DE PAGO DE ESTE DOCUMENTO", timeOut: 8000 });
            return
        }

        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const element = newOrderModel.Items[index];
            if (!element.newQuantity) {
                showAlert({ type: "warning", message: "El artículo " + element.ItemCode + " no tiene cantidad a devolver ", timeOut: 5000 });
                return;
            }
        }

        if (newOrderModel.DocStatus === "O" && (newOrderModel.NextFolio.slice(3, 5) === "DH" || this.state.ourInfoForReturn.isDeliveryInvoice === "Y") && ourInfoForReturn.paidOut === "N") {
            showAlert({ type: "info", message: "ESTE DOCUMENTO ES DE UNA VENTA A DOMICILIO SIN PAGAR", timeOut: 8000 });
            return
        }

        let OpenQty = 0;
        let Quantity = 0;

        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            item.Quantity = Number(item.newQuantity);

            OpenQty += Number(item.OpenQty);
            Quantity += Number(item.newQuantity);
            newItems.push(item);
        }
        newOrderModel.NumAtCard = OpenQty !== Quantity ? "" : newOrderModel.folio;
        if (newOrderModel.DocStatus === "C") {
            newOrderModel.U_FMB_RelatedFolio = newOrderModel.NumAtCard;
        }

        if (Number(newOrderModel.ObjType) === 15) {
            ObjType = "return";
            series = _user?.U_FMB_ValidateSeriesORDN;
        }

        if (Number(newOrderModel.ObjType) === 13) {
            ObjType = "creditNote";
            series = _user?.U_FMB_ValidateSeriesORIN;
            if (newOrderModel.U_UDF_UUID) {
                newOrderModel.U_FMB_UUID_RELACIONADO = [newOrderModel.U_UDF_UUID];
                newOrderModel.U_FMB_TIPO_REL = "01";
            }
        }

        if (Number(newOrderModel.OutstandingBalance) !== 0 && Number(newOrderModel.ObjType) === 13 && Number(newOrderModel.AbonadoTotal) !== 0) {
            if (Number(newOrderModel.Total) > Number(newOrderModel.AbonadoTotal)) {
                return showAlert({ type: "error", message: "EL MONTO DE DEVOLUCIÓN ES MAYOR AL TOTAL DEL PAGO RECIBIDO. NO ES POSIBLE DEVOLVER", timeOut: 50000 });
            } else if (Number(newOrderModel.Total) <= Number(newOrderModel.AbonadoTotal)) {
                showAlert({ type: "info", message: `SU DEUDA DE ESTE DOCUMENTO SE HA REDUCIDO `, timeOut: 50000 });
            }
        }

        let seriesUsers = series.split("|");
        let table = this.selectTable(ObjType);
        newOrderModel.SerieCode = seriesUsers[0];
        newOrderModel.idSession = idWorkShift;


        newOrderModel.DocDueDate = today;
        newOrderModel.TaxDate = today;
        newOrderModel.validReturn = newOrderModel.PaymentsToReturn.length > 0 ? false : validReturn;

        if (table.name === "ORIN") {
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                const element = newOrderModel.Items[index];
                if (element.PriceBefDi) {
                    element.Price_2 = element.Price;
                    element.Price = element.PriceBefDi;
                }
            }
        }
        // to fix the error "BASE DOCUMENT" HAS ALREADY BEEN CLOSED
        if (newOrderModel.DocStatus === "C") {
            await this.BrakeRelationDoc();
        }

        newOrderModel.auxDeliveriSerie = await this.GetSeriesByCurrentUserProp("U_FMB_ValidateSeriesODLN");
        newOrderModel.OriginDoc = "Counter-Devolver";

        const data = {
            destino: table.name,
            docSubType: table.docSubType,
            reserveInvoice: table.reserveInvoice,
            model: newOrderModel,
            Time: moment().format(),
            UserTime: moment().format("HH:mm:ss"),
            ReturnReservInvoice: ItsReserveInvoice,
            TempPartner: true,
            ClientVersion: currentVersion,
            validateAuthorizarion: authorization,
            comments: AuthorizationComments,
            AuthorizationFolio: relatedFolio,
        };
        enableSpinner(true);
        const createDocumentResponse = await apiClient.createNewDocumentPS(data);
        enableSpinner(false);

        if (!createDocumentResponse.status) {
            return showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud, " + createDocumentResponse.message, timeOut: 8000 });
        } else if (createDocumentResponse.status === 8) {
            $("#newUpdateModal").modal("show");
            return showAlert({ type: "info", message: createDocumentResponse.message, timeOut: 50000 });
        } else if (createDocumentResponse.status === 2) {
            showAlert({ type: "info", message: createDocumentResponse.message, timeOut: 8000 });
            let document = createDocumentResponse.data.serviceLayeResponse;
            let folio = createDocumentResponse.data.createdFolio;

            newOrderModel.DocNum = document.DocNum;
            newOrderModel.DocTime = document.DocTime;
            newOrderModel.DocEntry = document.DocEntry;
            newOrderModel.folio = folio;
            newOrderModel.NumAtCard = '';
            newOrderModel.RecoverIdSale = '';
            newOrderModel.Comments = '';
            newOrderModel.PaymentsToSale = [];
            newOrderModel.Items = [];
            newOrderModel.Total = 0;

            await this.setState({
                showBillModal: false,
                newOrderModel,
                isCancel: false,
                disableRecover: false,
                DownPayments: [],
                CreditNotes: [],
                showRefSaleModal: !this.state.showRefSaleModal,
                showBatchSelectionModal: false,
                FailedRequestDocument: true,
                WasUpdatedPartner: false,
                editModePartner: false,
                ItsComingFromModifiedPartner: false,
                RelatedPayMethodsByDoc: [],
                itsInterOpDoc: false,
                recoverDocument: false,
                ItsRecoverAuthoriInvoice: false,
                recoverInterOpTypeDoc: '',
                updatebusinessPartner: new BusinessPartnerPS(),
                auxRecoverDocData: null,
                showTemporalData: false,
            });
            $("#refSaleModal").modal("show");
            return;
        }

        const document = createDocumentResponse.data;

        if (table.name === "ORIN") {
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                const element = newOrderModel.Items[index];
                element.Price = element.Price_2;
            }
        }
        for (let x = 0; x < document.serviceLayeResponse.DocumentLines.length; x++) {
            const newservice = document.serviceLayeResponse.DocumentLines[x];
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                const service = newOrderModel.Items[index];
                if (newservice.ItemCode === service.ItemCode) {
                    newservice.ItemDescription = service.Dscription ?? "";
                }
            }
        }

        this.CloseOpenRefundOfPaymentsModal(false)
        newOrderModel.DocDate = document.serviceLayeResponse.DocDate;
        newOrderModel.DocTime = data.UserTime || document.serviceLayeResponse.DocTime;
        newOrderModel.folio = document.createdFolio;
        newOrderModel.next_Folio_Cons = document.next_Folio_Cons;

        newOrderModelCopia.next_Folio_Cons = document.next_Folio_Cons;
        newOrderModel.folio = document.createdFolio;
        newOrderModelCopia.CardCode = document.serviceLayeResponse.CardCode;
        newOrderModelCopia.CardName = document.serviceLayeResponse.CardName;
        newOrderModelCopia.Items = document.serviceLayeResponse.DocumentLines;
        newOrderModelCopia.DocDate = document.serviceLayeResponse.DocDate;
        newOrderModelCopia.DocTime = document.serviceLayeResponse.DocTime;
        newOrderModelCopia.folio = document.createdFolio;
        newOrderModelCopia.VatSum = document.serviceLayeResponse.VatSum;
        newOrderModelCopia.DocTotal = document.serviceLayeResponse.DocTotal;

        $("#refundModal").modal("hide");
        // all IV docId always be payed
        const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);
        if (infoFolio.folioID === "IV") {
            const creditNoteCreated = createDocumentResponse.data.createdFolio;
            const dataToPrint = {
                docsToPrintIds: [creditNoteCreated],
                typeDoc: 14
            }
            enableSpinner(true);
            const responseApi = await apiClient.getPrintDocsInfo(dataToPrint);
            enableSpinner(false);
            if (responseApi.status !== 1) {
                showAlert({ type: "error", message: `${responseApi.message}` });
                return;
            }

            await this.setState({
                docsToPrint: responseApi.data ?? [],
                typeDocPrint: "ORIN",
                ordersToAction: document,
                EnableEditButton: false,
                showPDFViewer: !this.state.showPDFViewer,
                ShowExtraActions: false
            });

            $("#pdfViewer").modal("show");

        } else {
            $("#refundTicketModal").modal("show");
            this.PrintDocuments("Devolucion", "80", newOrderModel);
        }

        await this.setState({
            newOrderModel: new NewOrderSales(),
            checkboxDataTables: (new Map()),
            newOrderModelCopia,
            pedido: "",
            ShowRefundOfPaymentsModal: false,
        });
    }

    CheckIfHaveSelectedReturnItems = async (myFunction, messageError) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { checkboxDataTables, newOrderModel, ShowRefundOfPaymentsModal, createdFromReserve, ItsReserveInvoice, isAuthorization } = this.state
        let docEntryArray = [];
        if (createdFromReserve) {
            showAlert({ type: "info", message: `ENTREGA DE FACTURA DE RESERVA. NO ES POSIBLE GENERAR DEVOLUCIONES` });
            return;
        }

        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                docEntryArray.push(newOrderModel.Items[id]);
            }
        }
        if (isAuthorization) { docEntryArray = newOrderModel.Items; }

        if (docEntryArray.length) {
            for (let index = 0; index < docEntryArray.length; index++) {
                const element = docEntryArray[index];
                if (element.newQuantity === 0) {
                    showAlert({ type: "warning", message: "La cantidad a devolver debe ser mayor a cero." });
                    return;
                }
                element.Quantity = element.newQuantity;
                element.OpenLneQty = element.newQuantity;
                element.BatchNumbers = [];

            }
        }

        if (docEntryArray.length === 0) {
            showAlert({ type: "warning", message: messageError });
            return;
        } else {
            // VALIDATE IF IS PARTIAL RETURN TO RETURN THE USER --- ISRAEL PIDIÓ QUE AHORA SI SE PUDIERA DEVOLVER LAS DE CREDITO NO PAGADAS DE FORMA PARCIAL
            // if (ourInfoForReturn.paidOut && ourInfoForReturn.paidOut === "N") {
            //     const isPartial = await this.CheckIfIsPartialReturn(newOrderModel, docEntryArray);
            //     if (isPartial) {
            //         showAlert({ type: "info", message: "DEVOLUCIÓN PARCIAL DENEGADA", timeOut: 8000 });
            //         showAlert({ type: "info", message: "El documento aun no tiene registrado un pago, cancela este documento y levanta uno nuevo.", timeOut: 10000 });
            //         return
            //     }
            // }
            // -----------------------------------
            newOrderModel.Items = docEntryArray;
            let itemsBatch = newOrderModel.Items.filter((item) => item.ManBtchNum === "Y");
            if (itemsBatch.length > 0) {
                let isBatchComplete = true;
                for (let index = 0; index < itemsBatch.length; index++) {
                    const item = itemsBatch[index];
                    item.SnBUoMQty = 0;
                    for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                        const batch = item.BatchNumbers[indez];
                        item.SnBUoMQty += Number(batch.newQuantity);
                    }
                    if (Number(item.SnBUoMQty) !== Number(item.newQuantity)) {
                        isBatchComplete = false;
                    }
                }
                if (!isBatchComplete) {
                    let batchItems = []
                    const docEntry = newOrderModel.NextFolio;
                    const counter = true;
                    for (let index = 0; index < itemsBatch.length; index++) {
                        const item = itemsBatch[index];
                        batchItems.push({ LineNum: item.LineNum, AuxLineNum: item.AuxLineNum, ItemCode: item.ItemCode, WhsCode: item.WhsCode, InvntSttus: item.InvntSttus })
                    }
                    const data = { batchItems, docEntry, counter, ItsReserveInvoice };
                    enableSpinner(true);
                    let batchsResponse = await apiClient.GetBatchsToReturn(data);
                    enableSpinner(false);

                    if (batchsResponse.status === 0) {
                        showAlert({ type: "error", message: `Ocurrió un error al consultar Lotes`, timeOut: 8000 });
                        return;
                    }
                    let isNewBatch = false;
                    for (let index = 0; index < newOrderModel.Items.length; index++) {
                        const item = newOrderModel.Items[index];
                        let deliveredQty = 0;
                        for (let index2 = 0; index2 < batchsResponse.data.length; index2++) {
                            const itemBatch = batchsResponse.data[index2];
                            if (item.LineNum === itemBatch.LineNum && item.ItemCode === itemBatch.ItemCode && item.WhsCode === itemBatch.WhsCode) {
                                if (itemBatch.AvailableBatchNumbers && itemBatch.AvailableBatchNumbers.length > 0) { isNewBatch = true; }
                                for (let index3 = 0; index3 < itemBatch.AvailableBatchNumbers.length; index3++) {
                                    const batch = itemBatch.AvailableBatchNumbers[index3];
                                    batch.Quantity = Number(batch.Quantity) ?? 0;
                                    deliveredQty += batch.Quantity;
                                }
                                item.AvailableBatchNumbers = itemBatch.AvailableBatchNumbers;
                                if (item.Quantity > deliveredQty) { item.AvailableBatchNumbers[0].Quantity += (item.Quantity - deliveredQty); }
                            }
                        }
                    }

                    if (isNewBatch) {
                        await this.setState({
                            newOrderModel,
                            showBatchSelectionModal: true,
                        });
                        $("#batchSelectionModal").modal("show");

                        await this.RefreshReturnTotal(newOrderModel);
                        if (!ShowRefundOfPaymentsModal) {
                            await this.EnableShowRefundOfPaymentsModal();
                        }

                    } else {
                        showAlert({ type: "error", message: `Ocurrió un error al consultar Lotes`, timeOut: 8000 });
                        return;
                    }

                } else {
                    // no lo borro porque pueden meter autorizaciones para devoluciones
                    // const isAuthorization = await this.ValidateAuthorization();
                    const isAuthorization = false;
                    if (!isAuthorization) {
                        await this.RefreshReturnTotal(newOrderModel);
                        if (!ShowRefundOfPaymentsModal) {
                            await this.EnableShowRefundOfPaymentsModal();
                        }
                        myFunction();
                    }
                }
            } else {
                await this.RefreshReturnTotal(newOrderModel);
                if (!ShowRefundOfPaymentsModal) {
                    await this.EnableShowRefundOfPaymentsModal();
                }
                myFunction();
            }


            newOrderModel.AuxViewCounter = "RefundModal";
            await this.toggleDocumentSelectedAll(true);
            await this.refreshModel(newOrderModel)
            // -----------------------------------
            // ORIGINAL
            // newOrderModel.Items = docEntryArray;
            // await this.RefreshReturnTotal(newOrderModel);
            // if (!ShowRefundOfPaymentsModal) {
            //     await this.EnableShowRefundOfPaymentsModal();
            // }
            // myFunction();
        }
    }

    CancelDocument = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const pedido = this.state.isAuthorization ? this.state.relatedFolio : this.state.pedido;
        const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);

        const data = {
            DocEntry: infoFolio.DocEntry,
            table: {
                name: infoFolio.table
            }
        }
        enableSpinner(true);
        const cancelDocument = await apiClient.cancelDocumentCounter(data);
        enableSpinner(false);

        if (cancelDocument.status !== 1) {
            showAlert({ type: "error", message: cancelDocument.message, timeOut: 5000 });
            return;
        }
        showAlert({ type: "success", message: cancelDocument.message, timeOut: 5000 });
    }

    updateCommentsAuthorizationModel = (event, index) => {
        const { AuthorizationComments } = this.state;
        AuthorizationComments[index].comment = event.nativeEvent.target.value;
        this.setState({
            AuthorizationComments
        });
    }

    ShowRefSaleModal = async () => {
        const { enableSpinner } = this.props;
        const { newOrderModel, FailedRequestDocument } = this.state
        await this.setState({
            showRefSaleModal: !this.state.showRefSaleModal,
        });

        if (FailedRequestDocument) {
            await this.setState({
                NextStepFunction: () => {
                    $('#detailClientModal').modal('hide');
                    this.CreateDocument();
                },
                ContinueWithoutSave: () => {
                    $('#detailClientModal').modal('hide');
                    this.CreateDocument();
                }
            });
            $("#detailClientModal").modal("show");

        } else {
            const isAuthorization = await this.ValidateAuthorization();
            if (!isAuthorization) {
                // the client ask show the info about customer to custom before send to cash register
                enableSpinner(true);
                const getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
                await this.GetPartnerAddresses(newOrderModel.CardCode);
                enableSpinner(false);

                await this.setState({
                    updatebusinessPartner: getPartnersResponse.data[0],
                    NextStepFunction: () => {
                        $('#detailClientModal').modal('hide');
                        this.CreateDocument();
                    },
                    ContinueWithoutSave: () => {
                        $('#detailClientModal').modal('hide');
                        this.CreateDocument();
                    }
                });
                $("#detailClientModal").modal("show");
            }
        }

    }

    PrintRefSale = async (type, paperSize, folio) => {
        let user = JSON.parse(localStorage.getItem('Timbra1currentUser'));
        let items = [];
        let payments = [];
        const today = new Date();
        const date = moment(new Date(today.getFullYear(), today.getMonth(), today.getDate())).format('YYYY-MM-DD');
        const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();

        let data = {
            Config: {
                TicketType: type,
                PaperSize: paperSize
            },
            Store: {
                Name: Datos_Empresa.Nombre + ' ' + Datos_Empresa.Sociedad,
                Address: user.Branch.Address || "",
                RFC: "",
                Phone: "",
                Logo: "",
                Footer: "",
                Consecutive: ""
            },
            BusinessPartner: {
                CardCode: "",
                CardName: "",
                RFC: "",
                Regime: "",
                Phone: "",
                AddressInvoice: "",
                AddressDelivery: ""
            },
            OrderSale: {
                DocNum: folio || "XXXX",
                DocDate: date + " " + time || "",
                DocOrigen: "",
                Seller: user.U_NAME || "",
                Cashier: user.USER_CODE || "",
                DocTotal: "",
                Subtotal: "",
                TaxTotal: "",
                TaxRate: "",
                DocCur: "",
                Items: items || "",
                Payments: payments || ""
            },
            CashCut: {
                Type: "",
                DocNum: "",
                DocDate: "",
                Cashier: "",
                DocTotal: "",
                DocCur: "",
                NumSales: "",
                NumReturns: "",
                NumCollects: "",
                TotalSale: "",
                TotalCash: "",
                TotalReturn: "",
                TotalCashIn: "",
                TotalCashOut: "",
                TotalCard: "",
                TotalTransfer: "",
                TotalCheck: "",
                TotalReturnAsPayment: "",
                TotalCredit: "",
                TotalCreditNote: "",
                TotalCollect: "",
                CashIns: [],
                CashOuts: [],
                Cards: [],
                Transfers: [],
                Checks: [],
                ReturnsAsPayment: [],
                Credits: [],
                CreditNotes: []
            }
        }
        data.Store.Logo = development == true ? "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"
            : Datos_Empresa.LogoBase64;

        let print = await apiClient.PrintDocuments(data);
    };

    //#endregion

    //#region ########## BATCHS #############################
    ShowBatchSelectionModal = async (nextStep) => {
        const { enableSpinner } = this.props;
        const { disableRecover, newOrderModel } = this.state;
        if (nextStep) {
            const isAuthorization = await this.ValidateAuthorization();
            if (!isAuthorization) {
                await this.setState({
                    showBatchSelectionModal: !this.state.showBatchSelectionModal,
                });

                if (newOrderModel.ObjType === 'deliveries') {
                    await this.ShowBillModal();
                    if (await this.CheckIfItsUniversalPartner() === true) {
                        $("#billModal").modal("show");
                    } else {
                        if (disableRecover) {
                            $("#billModal").modal("show");
                        } else {
                            $("#vmInvoice").modal("show");
                        }
                    }
                } else if (newOrderModel.ObjType === 'deliveries2') {
                    if (await this.CheckIfItsUniversalPartner()) {
                        enableSpinner(true);
                        let getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
                        this.GetPartnerAddresses(newOrderModel.CardCode);
                        newOrderModel.DeliveryAuthorization = 'I';
                        await this.refreshModel(newOrderModel)
                        enableSpinner(false);
                        await this.setState({
                            updatebusinessPartner: getPartnersResponse.data[0],
                            NextStepFunction: async () => {
                                $('#detailClientModal').modal('hide');
                                const isAuthorization = await this.ValidateAuthorization();
                                if (!isAuthorization) { this.CreateDocument(); }
                            },
                            ContinueWithoutSave: async () => {
                                $('#detailClientModal').modal('hide');
                                let isAuthorization = await this.ValidateAuthorization();
                                if (!isAuthorization) { this.CreateDocument(); }
                            }
                        });
                        $("#detailClientModal").modal("show");
                    } else {
                        await this.ShowBillModal();
                        $("#vmInvoice").modal("show");
                    }
                }
            }

        } else {
            await this.setState({
                showBatchSelectionModal: !this.state.showBatchSelectionModal,
            });
        }
    };

    ValidateBatch = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;
        if (newOrderModel.DocType === 'I') {
            if (newOrderModel.ObjType === 'deliveries') {
                let items = newOrderModel.Items || [];
                let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
                if (itemsBatch.length > 0) {
                    let isBatchComplete = true;
                    for (let index = 0; index < itemsBatch.length; index++) {
                        const item = itemsBatch[index];
                        item.SnBUoMQty = 0;
                        for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                            const batch = item.BatchNumbers[indez];
                            item.SnBUoMQty += Number(batch.Quantity);
                        }
                        if (Number(item.SnBUoMQty) !== Number(item.Quantity)) {
                            isBatchComplete = false;
                        }
                    }
                    if (!isBatchComplete) {
                        let itemCode = {};
                        let whs = {}
                        itemsBatch.sort((a, b) => {
                            if (a.ItemCode > b.ItemCode) {
                                return 1;
                            } else if (b.ItemCode > a.ItemCode) {
                                return -1;
                            } else {
                                if (a.WhsCode > b.WhsCode) {
                                    return 1;
                                } else if (b.WhsCode > a.WhsCode) {
                                    return -1;
                                } else {
                                    return 0;
                                }
                            }
                        });
                        itemsBatch = itemsBatch.filter((item) => {
                            if (itemCode[item.ItemCode] && whs[item.WhsCode]) {
                                return false
                            } else {
                                itemCode[item.ItemCode] = true;
                                whs[item.WhsCode] = true;
                                return true;
                            }
                        });
                        let newItemsBatchArray = []
                        for (let index = 0; index < itemsBatch.length; index++) {
                            const item = itemsBatch[index];
                            newItemsBatchArray.push({ ItemCode: item.ItemCode, WhsCode: item.WhsCode })
                        }
                        enableSpinner(true);
                        let batchsResponse = await apiClient.getBatchItems({ newItemsBatchArray });
                        enableSpinner(false);

                        if (batchsResponse.status === 0) {
                            showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                            return;
                        }
                        let isNewBatch = false;
                        for (let index = 0; index < newOrderModel.Items.length; index++) {
                            const item = newOrderModel.Items[index];
                            for (let index = 0; index < batchsResponse.data.length; index++) {
                                const itemBatch = batchsResponse.data[index];
                                if (item.ItemCode === itemBatch.ItemCode && item.WhsCode === itemBatch.WhsCode) {
                                    if (itemBatch.AvailableBatchNumbers && itemBatch.AvailableBatchNumbers.length > 0) {
                                        isNewBatch = true;
                                    }
                                    item.AvailableBatchNumbers = itemBatch.AvailableBatchNumbers;
                                }
                            }
                        }

                        if (isNewBatch) {
                            await this.setState({
                                newOrderModel,
                                showBatchSelectionModal: true,
                            });
                            $('#batchSelectionModal').modal('show');
                        } else {
                            showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                            return;
                        }

                    } else {
                        await this.validateAutorizationModels(newOrderModel);
                    }
                } else {
                    await this.validateAutorizationModels(newOrderModel);
                }
            } else {
                await this.CreateDocument(newOrderModel);
            }
        } else {
            await this.CreateDocument(newOrderModel);
        }
    }

    ShowBatch = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, disableRecover } = this.state;
        if (newOrderModel.DocType === 'I') {
            if ((newOrderModel.ObjType === 'deliveries' || newOrderModel.ObjType === 'deliveries') && !disableRecover) {
                let items = newOrderModel.Items || [];
                let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');

                if (itemsBatch.length > 0) {
                    for (let index = 0; index < itemsBatch.length; index++) {
                        const item = itemsBatch[index];
                        item.SnBUoMQty = 0;
                        for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                            const batch = item.BatchNumbers[indez];
                            item.SnBUoMQty += Number(batch.Quantity);
                        }
                    }
                    let itemCode = {};
                    let whs = {}
                    itemsBatch.sort((a, b) => {
                        if (a.ItemCode > b.ItemCode) {
                            return 1;
                        } else if (b.ItemCode > a.ItemCode) {
                            return -1;
                        } else {
                            if (a.WhsCode > b.WhsCode) {
                                return 1;
                            } else if (b.WhsCode > a.WhsCode) {
                                return -1;
                            } else {
                                return 0;
                            }
                        }
                    });
                    itemsBatch = itemsBatch.filter((item) => {
                        if (itemCode[item.ItemCode] && whs[item.WhsCode]) {
                            return false
                        } else {
                            itemCode[item.ItemCode] = true;
                            whs[item.WhsCode] = true;
                            return true;
                        }
                    });
                    let newItemsBatchArray = []
                    for (let index = 0; index < itemsBatch.length; index++) {
                        const item = itemsBatch[index];
                        newItemsBatchArray.push({ ItemCode: item.ItemCode, WhsCode: item.WhsCode })
                    }
                    enableSpinner(true);
                    let batchsResponse = await apiClient.getBatchItems({ newItemsBatchArray });
                    enableSpinner(false);

                    if (batchsResponse.status === 0) {
                        showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                        return;
                    }
                    let isNewBatch = false;
                    for (let index = 0; index < newOrderModel.Items.length; index++) {
                        const item = newOrderModel.Items[index];
                        for (let index = 0; index < batchsResponse.data.length; index++) {
                            const itemBatch = batchsResponse.data[index];
                            if (item.ItemCode === itemBatch.ItemCode && item.WhsCode === itemBatch.WhsCode) {
                                if (itemBatch.AvailableBatchNumbers && itemBatch.AvailableBatchNumbers.length > 0) {
                                    isNewBatch = true;
                                }
                                item.AvailableBatchNumbers = itemBatch.AvailableBatchNumbers;
                            }
                        }
                    }

                    if (isNewBatch) {
                        await this.setState({
                            newOrderModel,
                            showBatchSelectionModal: true,
                        });
                        $('#batchSelectionModal').modal('show');
                    } else {
                        showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                        return;
                    }
                }
            }
        }
    }
    //#endregion

    //#region ########## MAIL FUNCTIONS #####################
    RefreshSendMailModel = (sendMailModel) => {
        this.setState({ sendMailModel })
    }

    SendDocsByEmail = async (docsStruct) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { sendMailModel, docsToPrint, typeDocPrint } = this.state
        // var value = docsStruct.innerHTML;
        // var objToSend = JSON.stringify(value);
        let infoFolio = await _generalFunctions.getDocInfoByFolio(docsToPrint[0].docHeader.infoByFolio.folio ?? "")
        sendMailModel.docEntry = infoFolio.DocEntry
        let data = {
            sendMailModel,
            // docsStruct: objToSend,
            typeDoc: typeDocPrint,
            objType: infoFolio.num,
            infoDoc: [{
                cardCode: docsToPrint[0].docHeader.responseHeader.CardCode ?? "",
                folio: docsToPrint[0].docHeader.infoByFolio.folio ?? "",
                slpInfo: {
                    slpCode: docsToPrint[0].docHeader ? docsToPrint[0].docHeader.responseHeader.SlpCode : docsToPrint[0].docHeader.SlpCode || "",
                    slpName: docsToPrint[0].docHeader ? docsToPrint[0].docHeader.responseHeader.SlpName : docsToPrint[0].docHeader.SlpName || "",
                }
            }]
        }

        enableSpinner(true);
        let responseApi = await apiClient.SendPrintDocsByEmail(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ""}` });
            return;
        }
        showAlert({ type: "success", message: `${responseApi.message ?? ""}` });
    }

    SaveChangesInvoice = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { EditableDocModel, ordersToAction } = this.state
        let data = { EditableDocModel, ordersToAction }
        enableSpinner(true)
        let responseApi = await apiClient.SaveChangesOrderInvoice(data);
        enableSpinner(false)
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        showAlert({ type: "success", message: `DOCUMENTO Y SOCIO ACTUALIZADOS CORRECTAMENTE` });
        this.ChangeEditableMode()
        await this.setState({ docsToPrint: responseApi.data ?? [] });
    }

    ChangeEditableMode = async () => {
        await this.setState({ editableMode: !this.state.editableMode })
    }

    OpenSendMailModal = () => {
        $("#pdfSendMailModal").modal("show");
    }
    //#endregion

    //#region ########## RENDER #############################
    render() {
        const { notificationReducer: { showAlert } } = this.props;
        const {
            newOrderModel,
            newOrderModelCopia,
            groupNumList,
            _user,
            initialDate,
            finalDate,
            ordersToAction,
            ordersDocs,
            ordersSearchModel,
            showPDFViewer,
            docsToPrint,
            editableMode,
            EditableDocModel,
            detailDoc,
            //#region #### RETURNS ###
            actionSale,
            pedido,
            PaymentSaleModel,
            addingPay,
            checkboxDataTables,
            relatedPayMethodsByDoc,
            ShowRefundOfPaymentsModal,
            //#endregion
            AvailablePayments,
            ItsReturnBill,
            isCancel,
            isValidCFDI,
            ItsCreditInvoice,
            createdFromReserve,
            itsCancelCFDIAvailable,
            ItsReserveInvoice,
            relatedIncomingPayments,
            relatedDocs,
            typeDocPrint,
            EnableEditButton,
            sendMailModel,
            extraDocsToShow,
            ShowExtraActions,
            printhide,
            PaymentStatus,
            CancelFunction,
            showInitialCashModal,
            showCashCutModal,
            cashCut,
            extraPaymentsCashCut,
            objCharge,
            totalCashCut,
            TotalAmountSales,
            numSalesCashCut,
            moneyOuts,
            moneyEntries,
            lastDaySession,
            blindCashCut,
            ReturnedBlindCut,
            AuthorizationComments,
            showBatchSelectionModal,
            isAuthorization,
            flagIfDocPointsCard,
            returnedPoints,
            ifExistPayment,
            headerDocument,
            OptionsCancelCFDI,
            reasonsListCreditDebit,
            bankOptions = [],
        } = this.state;
        const action = this.state.actionSale;
        AvailablePayments.sort((a, b) => (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0));
        //#region ########## OBJECTS TOOLS #################################################
        let salesTools = {
            initialDate,
            finalDate,
            ordersSearchModel,
            ordersDocs,
            ordersToAction,
            showPDFViewer,
            docsToPrint,
            editableMode,
            EditableDocModel,
            detailDoc,
            groupNumList,
            ChangeInitialDate: this.ChangeInitialDate,
            ChangeFinalDate: this.ChangeFinalDate,
            RefreshSearchOrdersModel: this.RefreshSearchOrdersModel,
            SearchOrders: this.SearchOrders,
            GetDocFolio: this.GetDocFolio,
            SendDocsToPdfViewer: this.SendDocsToPdfViewer,
            ChangeEditableMode: this.ChangeEditableMode,
            RefreshDocModel: this.RefreshDocModel,
            SaveChangesOrderInvoice: this.SaveChangesOrderInvoice,
            ShowDocInfo: this.ShowDocInfo,
            CloseDocument: this.CloseDocument,
            UploadInvoice: this.UploadInvoice,
            CloseModalActions: this.CloseModalActions,
            ShowPDFViewer: () => {
                this.ShowPDFViewer();
                this.CloseRefundModal();
            },
        }

        const mailTools = {
            sendMailModel: sendMailModel,
            RefreshSendMailModel: this.RefreshSendMailModel,
            SendDocsByEmail: this.SendDocsByEmail
        }

        let checkbox = {
            data: checkboxDataTables,
            selectOne: this.toggleDocumentSelected,
            selectAll: this.toggleDocumentSelectedAll,
        }
        //#endregion

        return (
            <div className="content mb-5">
                <NavBar props={this.props} logoCounter={true} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={"DEVOLUCIÓN Y/O CANCELACIONES"} url1={"#"} />
                <div style={{ marginLeft: "4rem" }}>
                    <div className="row mr-3 mb-3 row-responsive"> <div className="col-12"><h3> Devolución y/o Cancelaciones </h3></div> </div>
                    <div className="row mr-3 mb-3 row-responsive">
                        <div className="col-12 col-md-4">
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">
                                        <strong>
                                            <span className="d-none d-lg-inline">Buscar documento</span>
                                            <span className="d-inline d-lg-none">Buscar</span>
                                        </strong>
                                        <ToolTip tips={tips.SearchRefund} position={"up"} />
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Folio"
                                    onKeyPress={(ev) => {
                                        if (ev.key === "Enter") {
                                            this.SearchSale();
                                        }
                                    }}
                                    onChange={({ target: { value } }) => this.ChangePedido(value)}
                                    value={pedido ? pedido : ""}
                                />
                                <div className="input-group-append">
                                    <button type="button" className="input-group-text" style={{ backgroundColor: "transparent", color: "#a1a9b1" }} onClick={this.SearchSale}>
                                        <i className="fas fa-search" />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-8">
                            {action === "cancel" && createdFromReserve &&
                                <></>
                                // <button
                                //     type="button"
                                //     className="btn btn-danger ml-2"
                                //     onClick={() => CancelDocument()}
                                // >
                                //     Cancelar SAP
                                // </button>
                            }

                        </div>

                        <div className="col-12 col-md-3 mb-1">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><strong>Cliente</strong></span>
                                </div>
                                <input type="text" className="form-control" disabled value={newOrderModel.CardCode} />
                            </div>
                        </div>
                        <div className="col-12 col-md-3 mb-1">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><strong>Nombre</strong></span>
                                </div>
                                <input type="text" className="form-control" disabled value={newOrderModel.CardName} />
                            </div>
                        </div>
                        <div className="col-12 col-md-6 text-right mb-1">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">
                                        <strong htmlFor="inputGroupSelect01">Operación:</strong>
                                        {this.selectTip().length > 0 &&
                                            <ToolTip tips={this.selectTip()} position={"up"} />
                                        }
                                    </span>
                                </div>
                                <select className="custom-select" id="inputGroupSelect04" disabled={isAuthorization} value={action} onChange={(event) => { if (!isAuthorization) { this.ChangeActionSale(event.target.value); } }}>
                                    <option value="">Elige una operación</option>
                                    <option value="refund">Devolución</option>
                                    {/* <option value="invoice">Facturación</option> */}
                                    {itsCancelCFDIAvailable && relatedDocs.length === 0 ?
                                        <option value="cancel">Cancelación CFDI</option>
                                        :
                                        relatedDocs.length === 0 ?
                                            <option value="cancelSale">Cancelar venta</option>
                                            :
                                            <></>
                                    }
                                </select>
                                <div className="input-group-append">
                                    {action === "" &&
                                        <button type="button" className="btn btn-outline-secondary ml-2" disabled >Realizar</button>
                                    }
                                    {action === "refund" &&
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary ml-2"
                                            onClick={() => this.CheckIfHaveSelectedReturnItems(() => this.CloseOpenRefundOfPaymentsModal(true), "Seleccione uno o varios artículos a devolver")}
                                        >
                                            Devolver
                                        </button>
                                    }
                                    {action === "invoice" &&
                                        <button type="button" className="btn btn-outline-primary ml-2" data-toggle="modal" onClick={() => salesTools.SendDocsToPdfViewer()}>Facturar</button>
                                    }

                                    {action === "cancel" && isValidCFDI &&
                                        <button
                                            type="button"
                                            className="btn btn-danger ml-2"
                                            data-toggle="modal"
                                            onClick={() => this.ShowCancelConfirm(true)}
                                        >
                                            Cancelar CFDI
                                        </button>
                                    }

                                    {action === "cancel" && isCancel &&
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger ml-2"
                                            data-toggle="modal"
                                            onClick={() => this.CloseOpenRefundOfPaymentsModal(true)}>
                                            Cancelar Venta
                                        </button>
                                    }

                                    {action === "cancel" && !isValidCFDI && !isCancel &&
                                        <button
                                            type="button"
                                            className="btn btn-info text-white"
                                            onClick={() => this.ConsultarEstatusCFDI(true)} >
                                            Consultar estatus
                                        </button>
                                    }

                                    {action === "cancelSale" && !itsCancelCFDIAvailable &&
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger ml-1"
                                            data-toggle="modal"
                                            onClick={this.ValidateCloseDocument}
                                        >
                                            Cancelar documento
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    {(action === "refund" || action === "cancelSale") &&
                        <div className="row mr-3 mb-3 row-responsive">
                            <div className="col-12 col-md-6 mb-1">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text"><strong>Comentarios</strong></span>
                                    </div>
                                    <textarea
                                        type="text"
                                        className="form-control"
                                        aria-label="With textarea"
                                        value={newOrderModel.Comments}
                                        onChange={this.ChangeComments}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-1">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-lg-inline">Motivo de Nota de Crédito</span>
                                            <span className="d-inline d-lg-none">Motivo N.Crédito</span>
                                        </span>
                                    </div>
                                    <select
                                        className="form-control"
                                        value={newOrderModel.U_STR_MtvoCD || ""}
                                        onChange={({ target: { value } }) => this.ChangeField("U_STR_MtvoCD", value)}>
                                        <option value=""> Seleccionar </option>
                                        {reasonsListCreditDebit.map((option, index) => <option key={`reason-${index}`} value={option.Code}> {option.Code} - {option.Name} </option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text d-flex align-items-center">
                                            <input
                                                type="checkbox"
                                                id="todosCheck"
                                                checked={newOrderModel.U_RS_SOLAPR === 'Y' ? true : false}
                                                onChange={() => this.ChangeField("U_RS_SOLAPR", '')}
                                                style={{
                                                    transform: 'scale(1.4)',
                                                    marginRight: '8px',
                                                    cursor: 'pointer'
                                                }}
                                            />
                                            <strong>Solicitar aprobación</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-3 mb-1">
                                {!!ItsCreditInvoice && ItsCreditInvoice &&
                                    <>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <strong>Abonado: </strong>
                                                    <ToolTip tips={[tips.CreditInvoice[0]]} position={"up"} />
                                                </span>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled
                                                value={CURRENCY + ' ' + FORMAT_NUMBER.new(newOrderModel.AbonadoTotal || 0)} />
                                        </div>


                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <strong>Saldo pendiente: </strong>
                                                    <ToolTip tips={[tips.CreditInvoice[1]]} position={"up"} />
                                                </span>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled
                                                value={CURRENCY + ' ' + FORMAT_NUMBER.new(newOrderModel.OutstandingBalance || 0)}
                                            />
                                        </div>

                                    </>
                                }

                            </div>
                        </div>
                    }

                    <div className="card scrollTableRefound mr-3 mb-3" style={{ maxHeight: "350px" }}>
                        <table className="table table-striped table-hover">
                            <thead>
                                {(action === "" || action === "invoice" || action === "cancel" || action === "cancelSale") &&
                                    <tr>
                                        <th className="text-center" scope="col">

                                        </th>
                                        <th className="text-center" scope="col">
                                            Código
                                        </th>
                                        <th className="col-12 col-md-6 text-center" scope="col">
                                            Nombre
                                        </th>
                                        <th className=" text-center" scope="col">
                                            Cantidad
                                        </th>
                                        <th className="text-center" scope="col">
                                            Estatus
                                        </th>
                                        <th className="text-center" scope="col">
                                            Precio U.
                                        </th>
                                        {ItsReturnBill &&
                                            <>
                                                <th className=" text-center" scope="col">
                                                    Descuento
                                                </th>
                                                <th className=" text-center" scope="col">
                                                    SubTotal
                                                </th>
                                            </>
                                        }
                                        <th className=" text-center" scope="col">
                                            Total linea
                                        </th>
                                    </tr>
                                }
                                {action === "refund" &&
                                    <tr>
                                        <th className="text-center">
                                            <input
                                                type="checkbox"
                                                style={{ minWidth: "100%", width: "15px", height: "15px" }}
                                                id="CheckAll"
                                                disabled={isAuthorization}
                                                onChange={(event) => { if (!isAuthorization) { checkbox.selectAll(event.target.checked); } }} />
                                        </th>
                                        <th className="text-center">
                                            Cantidad
                                            {ItsReserveInvoice &&
                                                <span className="d-inline-block font-weight-normal">
                                                    <ToolTip tips={[tips.ReserveInvoice[0]]} position={"down"} />
                                                </span>
                                            }
                                        </th>
                                        <th className="text-center">
                                            Estatus
                                            {ItsReserveInvoice &&
                                                <span className="d-inline-block font-weight-normal">
                                                    <ToolTip tips={[tips.ReserveInvoice[1]]} position={"down"} />
                                                </span>
                                            }
                                        </th>
                                        <th className="text-center">Código</th>
                                        <th className="text-center">Descripción</th>
                                        <th className="text-center" scope="col">Precio U.</th>
                                        {ItsReturnBill &&
                                            <>
                                                <th className="text-center" scope="col">Descuento</th>
                                                <th className="text-center" scope="col">SubTotal</th>
                                            </>
                                        }


                                        <th className="text-center" scope="col">Total linea</th>

                                    </tr>
                                }
                            </thead>
                            <tbody>
                                {/* invoice - return */}
                                {newOrderModel.Items && newOrderModel.Items.length > 0 && (action === "" || action === "invoice" || action === "cancel" || action === "cancelSale") &&
                                    newOrderModel.Items.map((line, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="text-center">
                                                    <input
                                                        type="checkbox"
                                                        style={{ minWidth: "100%", width: "15px", height: "15px" }}
                                                        disabled={true}
                                                        checked={true}
                                                    />
                                                </td>
                                                <td className="text-center">
                                                    <strong>{line.ItemCode ?? ""}</strong>
                                                </td>
                                                <td className="text-center">{line.Description ? line.Description : line.ItemName ? line.ItemName : ""}</td>
                                                <td className="text-center">
                                                    <input
                                                        className="text-center"
                                                        type="text"
                                                        disabled={true}
                                                        onChange={(event) => { this.ChangeQuantityRefund(index, line, event) }}
                                                        value={Number(line.OpenQty).toFixed(4) || ""}
                                                    />
                                                </td>
                                                <td className="text-center">{line.InvntSttus ? "ENTREGADO" : "PENDIENTE DE ENTREGA"}</td>
                                                <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(line.Price ?? 0))}</td>
                                                {ItsReturnBill &&
                                                    <>
                                                        <td className="text-center">{FORMAT_NUMBER.new(Number(line.Discount) ?? "") + " %"}</td>
                                                        <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(line.Total))}</td>

                                                    </>
                                                }
                                                {ItsReturnBill ?
                                                    <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(line.Total) + Number(line.VatSum))}</td>
                                                    :
                                                    <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new((Number(line.OpenQty) * Number(line.Price)) * ((100 + Number(line.TaxRate)) / 100))}</td>
                                                }
                                            </tr>
                                        );
                                    })
                                }
                                {/* return docs */}
                                {!!newOrderModel.Items && action === "refund" && newOrderModel.Items.map((doc, index) => {

                                    return (
                                        <tr key={index} >
                                            <td className="text-center">
                                                <input
                                                    type="checkbox"
                                                    style={{ minWidth: "100%", width: "15px", height: "15px" }}
                                                    id="CheckAll"
                                                    disabled={isAuthorization}
                                                    checked={isAuthorization || !!checkbox.data.get(index)}
                                                    onChange={() => { if (!isAuthorization) { checkbox.selectOne(index); } }} />
                                            </td>
                                            <td className="text-center">

                                                {this.IsInteger(Number(doc.OpenQty).toFixed(4))
                                                    ?
                                                    <strong>{parseInt(doc.OpenQty ?? 0)}{" / "}
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            className="text-left input-cantidad"
                                                            max={parseInt(doc.OpenQty)}
                                                            disabled={isAuthorization}
                                                            onChange={(event) => { if (!isAuthorization) { this.ChangeQuantityRefund(index, doc, event); } }}
                                                            value={doc.newQuantity}
                                                        />
                                                    </strong>
                                                    :
                                                    <>
                                                        <strong>{Number(doc.OpenQty ?? 0).toFixed(4)}{" / "}</strong>
                                                        <input
                                                            type="number"
                                                            className="text-left input-cantidadDeci"
                                                            disabled={isAuthorization}
                                                            onChange={(event) => { if (!isAuthorization) { this.ChangeQuantityRefund(index, doc, event); } }}
                                                            value={doc.newQuantity ?? ""}
                                                        />
                                                    </>

                                                }
                                            </td>
                                            <td className="text-center">{doc.InvntSttus ? "ENTREGADO" : "PENDIENTE DE ENTREGA"}</td>
                                            <td className="text-center">{doc.ItemCode}</td>
                                            <td className="text-left">{doc.Description}</td>
                                            <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(doc.Price ?? 0))}</td>
                                            {ItsReturnBill &&
                                                <>
                                                    <td className="text-center">{FORMAT_NUMBER.new(Number(doc.Discount) ?? "") + " %"}</td>
                                                    <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(doc.Total))}</td>

                                                </>
                                            }
                                            {ItsReturnBill ?
                                                <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(doc.Total) + Number(doc.VatSum))}</td>

                                                :
                                                <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new((Number(doc.OpenQty) * Number(doc.Price)) * ((100 + Number(doc.TaxRate)) / 100))}</td>
                                            }

                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="row mr-3 mb-3 row-responsive">
                        <div className="col-12 col-md-9 mt-1"></div>
                        <div className="col-12 col-md-3 text-right mt-1">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><strong>Subtotal</strong></span>
                                </div>
                                <input type="text" className="form-control text-right" disabled placeholder={(Number(newOrderModel.DocTotal || 0) - Number(newOrderModel.VatSum || 0)).toFixed(2)} />
                            </div>
                            <div className="input-group mt-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><strong>IGV</strong></span>
                                </div>
                                <input type="text" className="form-control text-right" disabled placeholder={Number(newOrderModel.VatSum || 0).toFixed(2)} />
                            </div>
                            <div className="input-group mt-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><strong>Total</strong></span>
                                </div>
                                <input type="text" className="form-control text-right" disabled placeholder={Number(newOrderModel.DocTotal || 0).toFixed(2)} />
                            </div>
                        </div>
                    </div>
                </div>

                {ShowRefundOfPaymentsModal &&
                    <RefundOfPaymentsModal
                        showAlert={showAlert}
                        newOrderModel={newOrderModel}
                        RelatedPayMethodsByDoc={relatedPayMethodsByDoc}
                        AvailablePayments={AvailablePayments}
                        PaymentSaleModel={PaymentSaleModel}
                        addingPay={addingPay}
                        RefreshOrder={this.RefreshOrder}
                        RefreshPaymentSaleModel={this.RefreshPaymentSaleModel}
                        Devolver={this.Devolver}
                        AddPay={this.AddPay}
                        CancelReturnPayment={this.CancelReturnPayment}
                        user={_user}
                        action={actionSale}
                        SalesTools={salesTools}
                        ItsCreditInvoice={ItsCreditInvoice} />
                }

                {showPDFViewer &&
                    <PdfViewer
                        DocsToPrint={docsToPrint}
                        TypeDoc={typeDocPrint}
                        EnableEditButton={EnableEditButton}
                        Editable={false}
                        ChangeEditableMode={() => { }}
                        EditableDocModel={salesTools.EditableDocModel}
                        RefreshDocModel={salesTools.RefreshDocModel}
                        SaveChanges={this.SaveChangesInvoice}
                        UploadDoc={salesTools.UploadInvoice}
                        EditParam1={false}
                        ShowPDFViewer={this.CloseCreatedInvoiceActions}
                        CreateDocument={() => { }}
                        OpenMailModal={this.OpenSendMailModal}
                        ItsFirme={true}
                        user={_user}
                        Counter={true}
                        MailTools={mailTools}
                        ExtraDocsToShow={extraDocsToShow}
                        ShowNextDocument={this.ShowNextDocument}
                        ShowExtraActions={ShowExtraActions}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                        reprint={false}
                        PointsCardModel={PointsCardModel} />
                }

                {PaymentStatus.length > 0 &&
                    <PaymentStatusListModal
                        data={PaymentStatus}
                        SearchPayment={() => { }}
                        CancelRelatedCFDI={this.ShowCancelConfirm}
                        ContinueToCancel={this.ContinueToCancel}
                        CancelPayments={this.CancelPayments}
                        cleanData={() => this.setState({ PaymentStatus: [] })}
                    />
                }

                <RefundTicketModal
                    newOrderModel={newOrderModelCopia}
                    CloseBillModal={this.CloseBillModal}
                    Print={() => this.PrintDocuments("Devolucion", "80", newOrderModelCopia)}
                    _user={_user} />

                <CancelCFDI
                    CancelDocuments={CancelFunction}
                    OptionsCancelCFDI={OptionsCancelCFDI} />


                {showInitialCashModal && (
                    <InitialCashModal
                        InsertWorkShiftT={this.InsertWorkShiftT}
                        CancelWorkShift={this.CancelWorkShift} />
                )}

                {showCashCutModal && (
                    <CashCutModal
                        ShowCashCutModal={this.ShowCashCutModal}
                        CashCut={cashCut}
                        ObjCharge={objCharge}
                        TotalCashCut={totalCashCut}
                        TotalAmountSales={TotalAmountSales}
                        NumVentas={numSalesCashCut}
                        extraPaymentsCashCut={extraPaymentsCashCut}
                        moneyEntries={moneyEntries}
                        moneyOuts={moneyOuts}
                        headerCashCut={{ U_NAME: "", docUpdate: "", endSession: "" }}
                        BranchOfficeGeneralCut={() => { }}
                        CloseWorkShift={this.CloseWorkShift}
                        GotoDashboard={this.SendToLogin}
                        lastDaySession={lastDaySession}
                        _user={_user}
                        blindCashCut={blindCashCut}
                        ShowBlindCashCut={this.ShowBlindCashCut}
                        ReturnedBlindCut={ReturnedBlindCut}
                        BlindCutByIdSession={[]}
                        bankOptions={bankOptions}
                    />
                )}

                {showBatchSelectionModal &&
                    <BatchSelectionModal
                        newOrderModel={newOrderModel}
                        showAlert={showAlert}
                        ShowBatchSelectionModal={this.ShowBatchSelectionModal}
                        refreshModel={this.refreshModel}
                        CloseOpenRefundOfPaymentsModal={this.CloseOpenRefundOfPaymentsModal} />
                }

                {AuthorizationComments.length > 0 &&
                    <AuthorizationModel
                        newOrderModel={newOrderModel}
                        comments={AuthorizationComments}
                        updateComments={this.updateCommentsAuthorizationModel}
                        createDocument={actionSale === "cancel" ? () => this.CloseDocument(true) : () => this.Devolver(true, true)} />
                }
                {flagIfDocPointsCard &&
                    <NotificationPointsCardModal
                        headerDocument={headerDocument}
                        relatedIncomingPayments={relatedIncomingPayments}
                        relatedDocs={relatedDocs}
                        cancelTimbra={this.cancelTimbra}
                        returnPointsCard={this.returnPointsCard}
                        returnedPoints={returnedPoints}
                        cleanData={() => this.setState({ flagIfDocPointsCard: false, ifExistPayment: false, returnedPoints: 0, newOrderModel: new NewOrderSales() })}
                    />
                }
                {ifExistPayment &&
                    <AreYouAgreeModal
                        mensaje={'¿Estás seguro de que deseas cancelar esta venta de monedero electrónico? Al darle clic en aceptar, se cancelará el pago ligado a la factura, lo que permitirá liberar la factura.'}
                        accept={this.CancelPaymentPointsCard}
                        cancel={this.CloseShowAreYouAgreeModal}
                    />
                }

                <RefSaleModal
                    ShowRefSaleModal={this.ShowRefSaleModal}
                    Folio={newOrderModel.folio}
                    PrintRefSale={this.PrintRefSale}
                    _user={_user}
                    CloseBillModal={this.CloseBillModal} />
            </div>
        );
    }
    //#endregion
}

const mapStateToProps = (store) => {
    return {
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        enableSpinner: (value) => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CounterReturns);